import React, { useState, useEffect } from "react";
import axios, { isCancel } from "axios";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import FormGroup from "@mui/material/FormGroup";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import FormControlLabel from "@mui/material/FormControlLabel";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Checkbox from "@mui/material/Checkbox";
import Switch from "@mui/material/Switch";
import moment from "moment-timezone";
import Paper from '@mui/material/Paper';
import RefreshIcon from "@mui/icons-material/Refresh";
import MicrosoftIcon from '@mui/icons-material/Microsoft';
import ListIcon from '@mui/icons-material/List';
import configs, { getParameterByName } from "../Constants";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import MenuList from '@mui/material/MenuList';
import MenuItem from "@mui/material/MenuItem";
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@mui/icons-material/Close";
import Chip from "@mui/material/Chip";
//import currencySymbol from 'currency-symbol'
import Currencies from "../root/currency";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-responsive-list";
import "react-responsive-list/assets/index.css";
import ListAltIcon from "@mui/icons-material/ListAlt";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import DriveEtaIcon from "@mui/icons-material/DriveEta";
import DinnerDining from "@mui/icons-material/DinnerDining";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import PrintIcon from "@mui/icons-material/Print";
import BillPrint from "./BillPrint";
import TokenIcon from "@mui/icons-material/Token";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { amber, purple } from "@mui/material/colors";
import { useIntl } from "react-intl";
import PaymentOptions from "./sub_comp/PaymentOptions";
import DatePicker from "react-datepicker"; // Make sure to install react-datepicker
import "react-datepicker/dist/react-datepicker.css"; // Import the styles for the date picker
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import Collapse from '@mui/material/Collapse';
import BillPopup from "./sub_comp/BillPopup";
import TempOrder from "./sub_comp/TempOrder";
import AssignDriverPopup from "./sub_comp/AssignDriverPopup"; // adjust path if needed
import AssignWaiterPopup from './sub_comp/AssignWaiterPopup';
import DeleteDiaologue from "./sub_comp/Delete";
import { useNavigate } from "react-router-dom";
import DiscountIcon from '@mui/icons-material/Discount';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import TableChartIcon from '@mui/icons-material/TableChart';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import {
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { printReceipt } from "./util";
import AudioManager from "./AudioManager";
const OrderList = (props) => {
  const orderListPath = `/orderList`;
  const [totalOrders, setTotalOrders] = useState([]);
  const [orderList, setOrderList] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [orderItemsList, setOrderItemsList] = useState([]);
  const [token, setToken] = useState(0);
  const [edit, setEdit] = useState(false);
  const [editQuantity, setEditQuntity] = useState(0);
  const [orderListId, setOrderListId] = useState();
  const [itemName, setItemName] = useState("");
  const [itemId, setItemId] = useState();
  const [alertOpen, setAlertOpen] = useState(false);
  const [notifiData, setNotifiData] = useState([]);
  const [openNotifi, setOpenNotifi] = useState(false);
  const [tabView, setTabView] = useState(false);
  const [tableData, setTableData] = useState(null);
  const [table1Data, setTable1Data] = useState([]);
  const [isSearch, setIsSearch] = useState(false);
  let timeOt = null;
  const [orderFilter, setOrderFilter] = useState([]);
  const [isDeliveryDialogOpen, setIsDeliveryDialogOpen] = useState(false);
  const [selectedDeliveryOrder, setSelectedDeliveryOrder] = useState(null);
  const [deliveryPartners, setDeliveryPartners] = useState([]);
  const [deliveryFormData, setDeliveryFormData] = useState({
    deliveryPartnerCode: '',
    thirdPartyOrderId: '',
    trackingId: '',
    trackingUrl: '',
    deliveryFee: '',
    deliveryNotes: ''
  });
  const [popUpOpen, setPopUpOpen] = useState(false);
  const closeModal = () => setPopUpOpen(false);
  const [showProducts, setShowProducts] = useState(true);
  const [waiter, setWaiter] = useState(false);
  const [kitchenView, setKitchenView] = useState(false);
  const [products, setProducts] = useState([]);
  const [itemCount, setItemCount] = useState(0);
  const [tablecall, setTableCall] = useState(false);
  const [customerData, setCustomerData] = useState([]);
  const [selectedOrd, setSelectedOrd] = useState([]);
  const [customerorderpop, setCustomerOrderPop] = useState(false);
  const [isReversed, setIsReversed] = useState(true);
  const [invoiceNo, setInvoiceNo] = useState("");
  const [printOrder, setPrintOrder] = useState(null);
  const [startBillPrint, setStartBillPrint] = useState(false);
  const [orderData, setOrderData] = useState([]);
  const { formatMessage: t, locale, setLocale } = useIntl();
  const [payModeSelectDialog, setPayModeSelectDialog] = useState(false);
  const [payModeIndx, setPayModeIndx] = useState(1);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [billPopupOpen, setBillPopupOpen] = useState(false);
  const [billDetails, setBillDetails] = useState(null);
  const [tempOrderView, setTempOrderView] = useState(1);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [deleteitemName, setDeleteItemName] = useState("");
  const [orderStatus, setOrderStatus] = useState("");
  const [tempOrders, setTempOrders] = useState([]);
  const [orderCancel, setOrderCancel] = useState(true);
  const [tableId, setTableId] = useState(null);
  const [OrderId, setOrderId] = useState(null);
  const [openActions, setOpenActions] = useState(false);
  const [assignPopupOpen, setAssignPopupOpen] = useState(false);
  const [selectedOrderForDriver, setSelectedOrderForDriver] = useState(null);
  const [selectedOrderForServer, setSelectedOrderForServer] = useState(null);
  const [dropdownPosition, setDropdownPosition] = useState("down"); // Can be 'up' or 'down'
  const [confirmRejectTempOrder, setConfirmRejectTempOrder] = useState(false);
  const [tempOrderToRejectId, setTempOrderToRejectId] = useState(null);
  const [printType, setPrintType] = useState("");
  const [searchShow, setSearchShow] = useState(false);
  const [kitchens, setKitchens] = useState([]);
  const [members, setMembers] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [viewMode, setViewMode] = useState('card'); // 'card' or 'table'
  const [infoExpanded, setInfoExpanded] = useState({});
  const [orderFilterType, setOrderFilterType] = useState('preparing'); // 'preparing', 'ready'
  const [tempOrderFilterType, setTempOrderFilterType] = useState('now'); // 'now', 'scheduled'
  const [payConfirmDialog, setPayConfirmDialog] = useState(false);
  const [report, setReport] = useState([]);
  const [refreshEventCounter, setRefreshEventCounter] = useState(0);
  const [showAllSuperAdminOrders, setShowAllSuperAdminOrders] = useState(false);
  const [merchantsCache, setMerchantsCache] = useState({});
  const [linkedVendors, setLinkedVendors] = useState([]);
  const [hasFetchedLinked, setHasFetchedLinked] = useState(false);

  const navigate = useNavigate();
  let baseURL = configs.baseURL;
  // let baseURL = "https://inventory-service-gthb.onrender.com";
  let authApi = configs.authapi;
  const theme = createTheme({
    palette: {
      info: amber,
      secondary: purple,
    },
  });
  const handleOrder = () => {
    setShowProducts(false);
  };
  let userData = localStorage.getItem("userData")
    ? JSON.parse(localStorage.getItem("userData"))
    : "";
  let merchantData = localStorage.getItem("merchantData")
    ? JSON.parse(localStorage.getItem("merchantData"))
    : null;
  const merchCode = merchantData ? merchantData.merchantCode : "";
  let userToken = localStorage.getItem("token") || "";

  const userId = userData && userData.isIAM ? userData.parentUser : userData.sub;
  const isSuperAdmin = userData && userData.role && userData.role.toLowerCase().replace('-', '') === 'superadmin';
  const isMultiVendorAdmin = userData && userData.role?.toUpperCase() === "MULTIVENDOR-ADMIN";
  const canViewMerchantDetails = isSuperAdmin || isMultiVendorAdmin;
  const getOrderList = `${baseURL}/api/orders/recent?merchantCode=${merchCode}${isSuperAdmin ? '&isSuperAdmin=true' : ''}`;
  // const getOrderList = `${baseURL}/api/orders/?merchantCode=${merchCode}`;
  const notificationURL = `${baseURL}/menu/notification/${userId}`;
  const deleteNOtificationUrl = `${baseURL}/menu/notifications/${userId}`;
  const getTabByUser = baseURL + "/api/tables?merchantCode=" + merchCode;
  const getProductByUser = baseURL + `/api/products?merchantCode=${merchCode}`;
  const formatter = new Intl.NumberFormat(localStorage.getItem("locale") || 'en-US', {
    style: 'currency',
    currency: merchantData.currency || 'USD'
  });
  //currecny
  let currency = Currencies.filter(
    (curen) => curen.abbreviation == merchantData.currency
  );
  console.log(currency);
  let SelectCurrency = currency && currency[0] ? currency[0].symbol : "";
  // console.log(SelectCurrency);
  const selectedCurrency = (
    <span dangerouslySetInnerHTML={{ __html: SelectCurrency }} />
  );


  useEffect(() => {
    const fetchMembers = async () => {
      try {
        const res = await axios.get(`${authApi}/user/members?userid=${userId}&open=true`);
        console.log(res.data);
        setMembers(res.data || []);
      } catch (err) {
        console.log("Failed to fetch members", err);
        setMembers([]);
      } finally {
        //setLoading(false);
      }
    };
    // const interval = setInterval(() => fetchOrdersAndNoti(), 10*1000);
    // return () => clearInterval(interval);
    fetchMembers();

  }, []);

  useEffect(() => {
    const fetchLinked = async () => {
      if (userData && userData.role?.toUpperCase() === "MULTIVENDOR-ADMIN") {
        try {
          const res = await axios.get(`${authApi}/user/linked-vendors?userId=${userData.sub}`, {
            headers: { 'Authorization': `Bearer ${userToken}` }
          });
          setLinkedVendors(res.data || []);
        } catch (err) {
          console.error("Error fetching linked vendors:", err);
        }
      }
      setHasFetchedLinked(true);
    };
    fetchLinked();
  }, [authApi, userToken]);

  useEffect(() => {
    if (!products.length) {
      axios.get(getProductByUser).then((response) => {
        if (response.data.length !== products.length) {
          setProducts(response.data);
          console.log(response.data);
        }
      });
    }
    if (merchantData?.bizVertical == 'restaurant') {
      fetchKitchens();
    }
  }, []);
  const encodeQueryData = (data) => {
    const ret = [];
    for (let d in data)
      ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
    return ret.join('&');
  }
  const fetchKitchens = async () => {
    try {
      const res = await axios.get(
        `${baseURL}/api/kitchens?merchantCode=${merchCode}`
      );
      console.log("getting", res.data);
      setKitchens(res.data);
    } catch (err) {
      console.error("Error fetching kitchens:", err);
    }
  };


  const handleActionsClose = () => {
    setOpenActions(false);
  };


  const fetchTempOrders = async () => {
    try {
      let merchantCodes = [merchCode];
      if (userData && userData.role?.toUpperCase() === "MULTIVENDOR-ADMIN") {
        linkedVendors.forEach(v => {
          if (v && v.merchantCode) merchantCodes.push(v.merchantCode);
          else if (typeof v === 'string') merchantCodes.push(v);
        });
      }
      merchantCodes = [...new Set(merchantCodes)].filter(c => c);

      const promises = merchantCodes.map(code =>
        axios.get(`${baseURL}/api/temporders/?merchantCode=${code}${isSuperAdmin ? '&isSuperAdmin=true' : ''}`)
          .catch(() => ({ data: [] }))
      );

      const results = await Promise.all(promises);
      let tempOrds = [];
      results.forEach(res => {
        let data = res.data || [];
        tempOrds = [...tempOrds, ...data.filter(ord => ord.paymentType)];
      });
      setTempOrders(prev => {
        if (tempOrds.length > prev.length) {
          try {
            AudioManager.play('temp_ord_sound');
          } catch(e) {
            console.log("Audio play error:", e);
          }
        }
        return tempOrds;
      });
    } catch (err) {
      console.log("Failed to fetch temp orders", err);
    }
  };

  useEffect(() => {
    if (hasFetchedLinked) {
      fetchTempOrders();
    }
  }, [baseURL, userToken, hasFetchedLinked, linkedVendors]);


  const handleOpenPopup = (order) => {
    setBillDetails(order);
    console.log("customerId", order.customerId);

    const ordersOnHold = JSON.parse(localStorage.getItem("orderOnHold")) || [];

    const updatedOrders = ordersOnHold.map((o) =>
      o.customerId === order.customerId ? { ...o, isDelivered: true } : o
    );
    localStorage.setItem("orderOnHold", JSON.stringify(updatedOrders));
    setBillPopupOpen(true);
  };

  const handleClosePopup = () => {
    setBillPopupOpen(false);
    setBillDetails(null);
  };

  const handleUpdateOrder = (order) => {
    const merchantInParam = getParameterByName("merchantCode");
    if (merchantInParam) {
      navigate(`/epos/${order.id || selectedOrder.id}?merchantCode=${merchCode}`);
    } else {
      navigate(`/epos/${order.id || selectedOrder.id}`);
    }
  }

  const orderListHandler = (orderId, customerId, order) => {

    setToken(order.number);
    setIsOpen(true);

    const SelectedorderItem = orderList.length
      ? orderList.filter((order) => order.id === orderId)
      : [];
    setSelectedOrd(SelectedorderItem);
    console.log(SelectedorderItem);

    axios
      .get(`${baseURL}/api/orders/${orderId}?merchantCode=${merchCode}`)
      .then((res) => {
        console.log(res.data);
        if (res.data.orderItems) {
          setOrderItemsList(res.data.orderItems);
        } else {
          setOrderItemsList(res.data);
        }
      });

    if (customerId) {
      console.log(customerId);
      axios
        .get(`${authApi}/customer/${customerId}`)
        .then((response) => {
          console.log(response.data);
          if (!response.data) {
            response.data = {};
          }
          setCustomerData(response.data);
          setCustomerOrderPop(true);
          console.log(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    console.log(SelectedorderItem);
  };

  const tempOrderListHandler = (orderId, customerId, order) => {
    console.log("order", order);
    setIsOpen(true);
    setToken(order.token || 0);
    setSelectedOrd([order]);
    setOrderItemsList(order.orderItems || []);

    //  If customerId is present, fetch from API (like in normal order)
    if (customerId) {
      axios
        .get(`${authApi}/customer/${customerId}`)
        .then((response) => {
          setCustomerData(response.data || {});
          setCustomerOrderPop(true);
        })
        .catch((err) => {
          console.log("Customer fetch error", err);
          setCustomerData({
            firstName: order.customerName || "N/A",
            phone: order.customerPhone || "N/A",
            address: order.customerAddress || "N/A",
          });
          setCustomerOrderPop(true);
        });
    } else {
      // If customerId is missing, fallback to available order fields
      setCustomerData({
        firstName: order.customerName || "N/A",
        phone: order.customerPhone || "N/A",
        address: order.customerAddress || "N/A",
      });
      setCustomerOrderPop(true);
    }
  };

  const handleClose = () => {
    setOrderItemsList([]);
    setIsOpen(false);
    setCustomerData([]);
    setCustomerOrderPop(false);
  };



  const handleOrderStatus = (order_Status, order_id, order_payment, order) => {
    console.log(order_id, order_payment);

    const SelectedorderItem = orderList.length
      ? orderList.filter((o) => o.id === order_id)
      : [];
    console.log(SelectedorderItem);
    setSelectedOrd(SelectedorderItem);

    const isTableOrder = order?.orderType === "Table Order";

    if (
      order_Status.toLowerCase() === "ready" ||
      order_Status.toLowerCase() === "deliver" ||
      order_Status.toLowerCase() === "intransit" ||
      order_Status.toLowerCase() === "confirm"
    ) {
      if (isTableOrder || order_payment || order_Status.toLowerCase() === "intransit" || order_Status.toLowerCase() === "confirm") {
        console.log(order_payment);
        const isEcomOrder = order?.isEcomList;
        const patchUrl = isEcomOrder
          ? `${baseURL}/api/ecom/orders/${order_id}?merchantCode=${merchCode}`
          : `${baseURL}/api/orders/${order_id}?merchantCode=${merchCode}`;

        let patchData = { action: order_Status };
        if (order_Status.toLowerCase() === "confirm") {
          patchData.orderStatus = "Confirmed";
        }

        axios
          .patch(patchUrl, patchData)
          .then((response) => {
            console.log("response data", response.data);
            let today = new Date();
            console.log(moment(today).format("DD/MMM/YYYY"));
            fetchOrdersAndNoti();

            if (!isEcomOrder) {
              if (order && order_Status.toLowerCase() === "ready") {
                HandleReady([order]);
              } else if (order && order_Status.toLowerCase() === "deliver") {
                HandleServed([order]);
              }
            }
            handleRefresh();
          });
      } else {
        setAlertOpen(true);
      }
    } else if (order_Status.toLowerCase() === "new" && isTableOrder) {
      // If orderStatus is NEW and orderType is Table Order, proceed to next step
      console.log("Table Order with NEW status, proceeding...");

      fetchOrdersAndNoti();
    } else {
      // axios
      //   .delete(`${baseURL}/api/orders/${order_id}?merchantCode=${merchCode}`, {
      //     action: orderStatus,
      //   })
      //   .then((response) => {
      //     console.log(response.data);
      //     let today = new Date();
      //     console.log(moment(today).format("DD/MMM/YYYY"));
      //     axios.get(getOrderList).then((response) => {
      //       console.log("response for orders", response.data);
      //       setOrderList(response.data);
      //     });
      //   });
      // console.log(orderStatus);
      setDeleteItemId(order_id);
      setOrderStatus(order_Status);
      setOpenDeleteDialog(true);
    }
  };

  console.log("orderlist for checking", orderList);

  const handleDeleteClose = () => {
    setOpenDeleteDialog(false);
    setDeleteItemId(null);
  };

  const event_handler3 = (event) => {
    try {
      console.info('EVENT: Received event refund-----');

      var data;
      data = event.data;
      console.log(data);

      if (data && typeof data == 'string' && (JSON.parse(data)?.result == "FAILURE" || JSON.parse(data)?.result == "CANCELLED" || JSON.parse(data)?.result == "NOCONNECTION" || JSON.parse(data)?.result == "SUCCESS")) {
        setPayConfirmDialog(false);
      }

    }
    catch (e) {
      console.log(e);
    }
  }



  useEffect(() => {
    if (userData?.paymentProviderType?.toLowerCase() == 'verifone') {
      window.addEventListener('message', (event) => event_handler3(event, setPayConfirmDialog), false);
    }
  }, []);

  const handleConfirmDelete = () => {
    if (!deleteItemId) {
      return;
    }
    axios
      .delete(
        `${baseURL}/api/orders/${deleteItemId}?merchantCode=${merchCode}`,
        {
          action: orderStatus,
        }
      )
      .then((response) => {
        console.log(response.data);
        let today = new Date();
        console.log(moment(today).format("DD/MMM/YYYY"));
        fetchOrdersAndNoti();
      });
    console.log(orderStatus);

    setOpenDeleteDialog(false);
    setDeleteItemId(null);
  };

  const handleCancel = async (order_id, order_cancel, tableId, orderNum) => {
    setOrderId(order_id);
    setOrderCancel(order_cancel);
    setTableId(tableId);
    setDeleteItemName(`Order Token/Table#: ${orderNum}`);
    setOpenDeleteDialog(true);
  };

  const handleCancelClose = () => {
    setOrderId(null);
    setOrderCancel("");
    setTableId(null);
    setOpenDeleteDialog(false);
  };

  const handleConfirmCancel = async () => {
    try {
      const order = orderList.find((o) => o.id === OrderId || o._id === OrderId);
      const isEcomOrder = order?.isEcomList;
      const patchUrl = isEcomOrder
        ? `${baseURL}/api/ecom/orders/${OrderId}?merchantCode=${merchCode}`
        : `${baseURL}/api/orders/${OrderId}?merchantCode=${merchCode}`;

      await axios.patch(
        patchUrl,
        {
          action: "cancel",
        }
      );
      if (tableId) {
        await axios.patch(
          `${baseURL}/api/tables/${tableId}/availability?merchantCode=${merchCode}`
        );
      }
      fetchOrdersAndNoti();
    } catch (error) {
      console.error("Error while cancelling order or updating table:", error);
    }
    setOrderId(null);
    setOrderCancel(true);
    setTableId(null);
    setOpenDeleteDialog(false);
    if (userData.paymentProviderType.toLowerCase() == 'verifone') {
      let ord = orderList.filter(or => or._id == OrderId);
      refund_tx(ord?.[0]?.paymentRefData);
    }

  };

  const getNewInvoice = (orderItms) => {
    return new Promise((resolve, reject) => {
      try {
        let billData = {};
        billData.userId = merchantData.merchantCode;
        billData.appName = "EPOS";
        billData.payType = "onetime";
        billData.payStatus = "paid";
        billData.purchaseItems = JSON.stringify(orderItms);

        axios
          .post(`${configs.payUrl}/api/new-order`, billData)
          .then((res) => {
            setInvoiceNo(res.data.invoiceData.invoicePath);
            resolve(res.data.invoiceData);
          });

      } catch (err) {
        reject(err);
      }
    })
  }

  const handlePayment = async (mode) => {
    if (selectedOrder && (selectedOrder.id || selectedOrder._id)) {
      try {
        let invData = await getNewInvoice(selectedOrder.orderItems || []);

        const orderEndpoint = selectedOrder.isEcomList
          ? `${baseURL}/api/ecom/orders/${selectedOrder.id || selectedOrder._id}?merchantCode=${merchCode}`
          : `${baseURL}/api/orders/${selectedOrder.id || selectedOrder._id}?merchantCode=${merchCode}`;

        axios
          .patch(orderEndpoint, {
            paymentState: "PAID",
            isPaid: true,
            payVia: mode,
            invoiceId: invData._id,
            action: 'pay'
          })
          .then((response) => {
            console.log(response);
            fetchOrdersAndNoti();
            setPayModeSelectDialog(false);
            setSelectedOrder(null);
            handleRefresh();
          });
      } catch (err) {
        console.error("Failed to generate invoice", err);
      }
    }


    if (selectedOrder?.orderType.toUpperCase() == "TABLE ORDER") {
      const tabData = tableData.filter((tab) => tab.number == selectedOrder?.number);
      if (tabData.length > 0) {
        axios
          .patch(
            `${baseURL}/api/tables/${tabData[0].id}/availability/?merchantCode=${merchantData ? merchantData.merchantCode : " "
            }`
          )
          .then((res) => {
            console.log(res.data);
            setPayModeSelectDialog(false);
            setSelectedOrder(null);
          });
      }
    }

  };

  const handleEdit = (itemId) => {
    console.log(itemId);
    const itmName =
      orderItemsList.length &&
      orderItemsList.map(
        (o) =>
          o._id === itemId &&
          setItemName(o.name) & setEditQuntity(o.quantity) & setItemId(o._id)
      );
    console.log(itmName);
    setEdit(true);
  };

  const handleInput = (event) => {
    console.log(event.target.value);
    setEditQuntity(event.target.value);
  };

  const habdleSubmit = (event) => {
    event.preventDefault();
    console.log(editQuantity);

    const updateItems = orderItemsList.map((ordListItem) => {
      if (ordListItem._id === itemId) {
        ordListItem.quantity = editQuantity;
        //ordListItem.price= ordListItem
      }
      return ordListItem;
    });
    console.log(updateItems);

    axios
      .patch(baseURL + "/api/orders/" + orderListId, { orderItems: updateItems })
      .then((res) => {
        console.log(res.data);
        let today = new Date();
        console.log(moment(today).format("DD/MMM/YYYY"));
        fetchOrdersAndNoti();
      });
    const updatePrice = orderItemsList.filter((oli) => oli._id === itemId);
    const ordPrice = orderList.filter((ol) => ol._id === orderListId);
    console.log(updatePrice[0].price, editQuantity, ordPrice[0].totalPrice);
    setEdit(false);
  };

  const HandleServed = (order, itemId) => {
    console.log(order);
    console.log(itemId);
    if (order) {
      let updatedOrderItems = order[0].orderItems.map((ord) => {
        console.log(ord._id);
        console.log(itemId);
        {
          if (ord._id === itemId || !itemId) {
            console.log("Updated");
            ord.status = "delivered";
          }
          return ord;
        }
      });
      order[0].orderStatus = "Delivered";
      console.log(order[0].orderItems);
      setOrderItemsList(updatedOrderItems);

      let patchPayload = {
        orderItems: updatedOrderItems,
      };

      if (order[0].orderSource === "Online Order") {
        patchPayload.orderStatus = "DELIVERED";
        patchPayload.action = "deliver";
      }

      axios.patch(baseURL + "/api/orders/" + order[0].id, patchPayload).then(() => {
        fetchOrdersAndNoti();
      });
    }
  };

  const HandleReady = (order, itemId) => {
    console.log(order);
    console.log(itemId);
    if (order) {
      let updatedOrderItems = order[0].orderItems.map((ord) => {
        if (ord._id === itemId || !itemId) {
          ord.status = "ready";
        }
        return ord;
      });
      setOrderItemsList(updatedOrderItems);
      axios.patch(baseURL + "/api/orders/" + order[0].id, {
        orderItems: updatedOrderItems,
      }).then(() => {
        fetchOrdersAndNoti();
      });
    }
  };

  const handleDelete = (name, price, quantity, itemId) => {
    console.log(itemId);
    setDeleteItemName(name);
    setDeleteItemId(itemId);
    setOpenDeleteDialog(true);
  };

  const fetchOrdersAndNoti = () => {
    let today = new Date();
    console.log(moment(today).format("DD/MMM/YYYY"));

    let merchantCodes = [merchCode];
    if (userData && userData.role?.toUpperCase() === "MULTIVENDOR-ADMIN") {
      linkedVendors.forEach(v => {
        if (v && v.merchantCode) merchantCodes.push(v.merchantCode);
        else if (typeof v === 'string') merchantCodes.push(v);
      });
    }
    merchantCodes = [...new Set(merchantCodes)].filter(c => c);

    const promises = [];
    merchantCodes.forEach(code => {
      const getOrderListUrl = `${baseURL}/api/orders/recent?merchantCode=${code}${isSuperAdmin ? '&isSuperAdmin=true' : ''}`;
      const getEcomOrderListUrl = `${baseURL}/api/ecom/orders?merchantCode=${code}${isSuperAdmin ? '&isSuperAdmin=true' : ''}`;

      promises.push(axios.get(getOrderListUrl).catch(() => ({ data: [] })));
      promises.push(axios.get(getEcomOrderListUrl).catch(() => ({ data: [] })));
    });

    Promise.all(promises).then((results) => {
      let merged = [];
      for (let i = 0; i < results.length; i += 2) {
        const ordersRes = results[i];
        const ecomOrdersRes = results[i + 1];
        merged = [...merged, ...(ordersRes.data || []), ...(ecomOrdersRes.data || []).map(o => ({ ...o, isEcomList: true }))];
      }
      merged.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      setOrderList(merged);
    });


    // axios.get(notificationURL).then((response)=>{
    //     setNotifiData(response.data);
    // });
    console.log(props.refesh);

    axios.get(getTabByUser).then((response) => {
      console.log(response.data);
      setTableData(response.data);
    });
  };

  const fetchOrdersByDate = (date) => {
    if (!date) return;
    const fromDate = moment(date).tz(merchantData.timezone || moment.tz.guess()).startOf("day");
    const toDate = moment(date).tz(merchantData.timezone || moment.tz.guess()).endOf("day");

    console.log("Fetching for date:", fromDate);

    const startStr = fromDate.format("YYYY-MM-DD");
    const endStr = toDate.format("YYYY-MM-DD");

    let merchantCodes = [merchCode];
    if (userData && userData.role?.toUpperCase() === "MULTIVENDOR-ADMIN") {
      linkedVendors.forEach(v => {
        if (v && v.merchantCode) merchantCodes.push(v.merchantCode);
        else if (typeof v === 'string') merchantCodes.push(v);
      });
    }
    merchantCodes = [...new Set(merchantCodes)].filter(c => c);

    const promises = [];
    merchantCodes.forEach(code => {
      const getOrderListUrl = `${baseURL}/api/orders/recent?merchantCode=${code}&start_date=${startStr}&end_date=${endStr}${isSuperAdmin ? '&isSuperAdmin=true' : ''}`;
      const getEcomOrderListUrl = `${baseURL}/api/ecom/orders?merchantCode=${code}${isSuperAdmin ? '&isSuperAdmin=true' : ''}`;
      const getReportUrl = `${baseURL}/api/orders/report/${code}?start_date=${fromDate}&end_date=${toDate}`;

      promises.push(axios.get(getOrderListUrl).catch(() => ({ data: [] })));
      promises.push(axios.get(getEcomOrderListUrl).catch(() => ({ data: [] })));
      promises.push(axios.get(getReportUrl).catch(() => ({ data: [] })));
    });

    Promise.all(promises).then((results) => {
      let mergedData = [];
      let reportData = [];
      for (let i = 0; i < results.length; i += 3) {
        const res = results[i];
        const ecomRes = results[i + 1];
        const reportRes = results[i + 2];

        let batchMerged = [...(res.data || []), ...(ecomRes.data || []).map(o => ({ ...o, isEcomList: true }))];
        mergedData = [...mergedData, ...batchMerged];
        reportData = [...reportData, ...(reportRes.data || [])];
      }

      let tzRes = mergedData.map(rp => { rp.createdAt = moment(rp.createdAt).tz(merchantData.timezone); return rp })
      let recents = tzRes.filter((item) => {
        const itemTime = new Date(item.updatedAt).getTime();
        const fromTime = new Date(fromDate).getTime();
        const toTime = new Date(toDate).getTime() + 86400000;

        const isDateInRange = itemTime >= fromTime && itemTime < toTime;
        const isActiveDelivery = item.orderType?.toLowerCase() === 'delivery' && !item.isDelivered && !item.isCanceled && item.orderStatus?.toLowerCase() !== 'rejected';

        return isDateInRange || isActiveDelivery;
      });

      setReport([...recents, ...reportData]);
    });
  };

  useEffect(() => {
    if (selectedDate && hasFetchedLinked) {
      fetchOrdersByDate(selectedDate);
    }
  }, [selectedDate, hasFetchedLinked, linkedVendors]);

  useEffect(() => {
    if (hasFetchedLinked) {
      fetchOrdersAndNoti();
    }
  }, [props.refesh, hasFetchedLinked, linkedVendors]);

  useEffect(() => {
    const handleRefreshEvent = () => {
      setRefreshEventCounter(prev => prev + 1);
    };
    window.addEventListener('refresh_orders', handleRefreshEvent);
    return () => {
      window.removeEventListener('refresh_orders', handleRefreshEvent);
    };
  }, []);

  useEffect(() => {
    if (refreshEventCounter > 0) {
      fetchTempOrders();
      fetchOrdersAndNoti();
    }
  }, [refreshEventCounter]);



  const handleRefresh = () => {
    console.log("API CALLED");
    setReport([]);
    setSelectedDate(new Date());
    fetchOrdersAndNoti();
    fetchTempOrders();
  };

  const handleUploadDeliveryPic = async (event, orderId) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("uploader", file);

    const toastId = toast.loading("Uploading delivery image...");

    try {
      const response = await axios.post(`${baseURL}/api/upload/deliveries`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userToken}`,
        },
      });

      if (response.data && response.data.results && response.data.results.length > 0) {
        const fullImageUrl = response.data.results[0].location;
        const imageName = fullImageUrl.split('/').pop();

        await axios.patch(`${baseURL}/api/orders/${orderId}?merchantCode=${merchCode}`, {
          deliveryImage: imageName
        }, {
          headers: { Authorization: `Bearer ${userToken}` }
        });

        toast.update(toastId, {
          render: "Delivery image uploaded successfully!",
          type: "success",
          isLoading: false,
          autoClose: 3000,
        });
        fetchOrdersAndNoti();
      } else {
        toast.update(toastId, {
          render: "Failed to upload image. Server response invalid.",
          type: "error",
          isLoading: false,
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error("Failed to upload delivery image:", error);
      toast.update(toastId, {
        render: "Failed to upload delivery image.",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    }
  };

  const handlePrintLabel = async (order) => {
    if (window.PrintInterface || window?.chrome?.webview?.postMessage) {
      try {
        const url = order.invoiceId
          ? `${configs.payUrl}/api/invoices/${order.invoiceId}`
          : `${configs.payUrl}/api/proforma-invoices/${order.id}`;
        const response = await axios.get(url);
        order.invoice_path = response.data.invoicePath;
      } catch (e) {
        console.error("Error fetching invoice for label:", e);
      }
      const orderData = {
        orderId: order ? (order._id || order.id) : "",
        merchantCode: merchCode ? merchCode : "",
        currency: currency.length && currency[0].abbreviation,
        restaurant: merchantData?.firstName || "",
        address: merchantData ? merchantData.address || userData.address : "",
        cgst: merchantData.taxPerc,
        taxPerc: merchantData.taxPerc,
        receiptNote: merchantData.receiptNotes || "",
        cashier: userData.sub == order.orderTakenById ? userData.firstName : (members.length ? members.filter(mb => (mb.id || mb.sub || mb._id) == order.orderTakenById)[0]?.firstName : userData.firstName),
        invoice_no: order.invoice_path || order.invoicePath || order.invoice_no || invoiceNo || "-",
        printType: "label",
        kitchens: kitchens,
        logoImg: merchantData.logoImg
      };

      const ordDetails = { ...order, ...orderData };
      printReceipt(ordDetails, merchantData, [], t, formatter);
      toast.success("Labels sent to printer successfully!");
    } else {
      toast.error("Native printing is not available on this browser.");
    }
  };

  const handleNotification = () => {
    axios.get(notificationURL).then((response) => {
      console.log(response.data);
      setNotifiData(response.data);
    });
    setOpenNotifi(true);
  };

  const handleClear = () => {
    //console.log("Clear All Data");
    axios.delete(deleteNOtificationUrl).then((response) => {
      //console.log(response.data);
      // setNotifiData(response.data);
      setOpenNotifi(false);
      props.setNotification(false);
    });
  };

  const handleTableOrders = () => {
    setTabView(tabView ? false : true);
  };

  const handleTypeOrder = (e) => {
    let val = e.target.value;
    //console.log(val);
    let fltOrder = orderList.filter((ord) => ord.orderType == val);
    //console.log(fltOrder);
    setOrderFilter(fltOrder);
    setIsSearch(val ? true : false);
  };

  const handlecheckprintKOT = async (order) => {
    try {
      try {
        const url = order.invoiceId
          ? `${configs.payUrl}/api/invoices/${order.invoiceId}`
          : `${configs.payUrl}/api/proforma-invoices/${order.id}`;
        const response = await axios.get(url);
        order.invoice_path = response.data.invoicePath;
      } catch (e) {
        console.error("Error fetching invoice for KOT:", e);
      }
      const formatter = new Intl.NumberFormat(localStorage.getItem("locale") || 'en-US', {
        style: 'currency',
        currency: merchantData?.currency || 'USD'
      });
      order['tokenNo'] = "Token #" + order.number;
      order["header1"] = t({ id: "items" });
      order["header2"] = t({ id: "quantity" });
      order["header3"] = t({ id: "amountlbl" });
      order["invoiceNo"] = t({ id: "invoice" }) + "#:" + (order.invoice_path || order.invoicePath || order.invoice_no);
      let mDate = moment(order.createdAt || new Date());
      if (merchantData?.timezone) {
        mDate = mDate.tz(merchantData.timezone);
      } else if (moment.tz.guess()) {
        mDate = mDate.tz(moment.tz.guess());
      }
      order["date"] = mDate.format("DD-MMM-YYYY h:mm a");
      order.orderItems = [];
      //let kitchensUsed =[];
      let AddorderItems =
        order &&
        order.orderItems &&
        order.orderItems.map((item, index) => {
          const subPro = item.sub_pro ? JSON.parse(item.sub_pro) : {};
          const addonNames = subPro.addons
            ?.map((a) => a.name)
            .join(", ");
          const varietyNames = subPro.variety
            ? Object.keys(subPro.variety).join(", ")
            : "";
          const cookInst = subPro.cookInstructions.join(',');
          item.price = formatter.format(item.price).replace('JMD', 'J$').replace(/\s+/, "");
          item.quantity = item.select_type === "weight"
            ? `${(item.quantity / 1000).toFixed(2)}K/L `
            : item.quantity;
          item.addOnsStr = addonNames;
          item.varNames = varietyNames;
          item.notes = cookInst;
          // if(item.kitchenId && kitchensUsed.indexOf(item.kitchenId) == -1){
          //     kitchensUsed.push(item.kitchenId);
          // }
          order.orderItems.push(item);
        });

      printKOT(order); // Set the order too
      //setInvoiceNo(response.data.invoicePath);
    } catch (error) {
      //setPrintOrder(order);
      console.error("Error calling order API:", error);
    }
  };

  const handlecheckprint = async (order) => {
    try {
      const url = order.invoiceId
        ? `${configs.payUrl}/api/invoices/${order.invoiceId}`
        : `${configs.payUrl}/api/proforma-invoices/${order.id}`;

      const response = await axios.get(url);

      setPrintType('receipt');
      order.invoice_path = response.data.invoicePath;
      setInvoiceNo(response.data.invoicePath);
      setPrintOrder(order);
    } catch (error) {
      setPrintType('receipt');
      setInvoiceNo("" + new Date().getTime());
      setPrintOrder(order);
      //console.error("Error calling order API:", error);
    }
  };

  // ⏬ This useEffect will run once invoiceNo is set
  useEffect(() => {
    if (printOrder) {

      handlePrint(printOrder);

    }
  }, [printOrder]);

  const getOrderPrintDetails = () => {
    let orderDet = printOrder;
    console.log(orderDet);
    let orderData = {
      orderId: orderDet ? (orderDet._id || orderDet.id) : "",
      merchantCode: merchCode ? merchCode : "",
      currency: currency.length && currency[0].abbreviation,
      restaurant: merchantData?.firstName || "",
      address:
        userData || merchantData
          ? merchantData.address || userData.address
          : "",
      cgst: merchantData.taxPerc,
      taxPerc: merchantData.taxPerc,
      receiptNote: merchantData.receiptNotes || "",
      cashier: userData.sub == orderDet.orderTakenById ? userData.firstName : (members.length ? members.filter(mb => (mb.id || mb.sub || mb._id) == orderDet.orderTakenById)[0]?.firstName : userData.firstName),
      invoice_no: orderDet ? (orderDet.invoice_path || orderDet.invoicePath || orderDet.invoice_no || invoiceNo || orderDet.number) : (invoiceNo ? invoiceNo : "-"),
      printType: printType,
      kitchens: kitchens,
      logoImg: merchantData.logoImg
    };

    if (orderDet.orderType == "Table Order" && merchantData?.dining_service_charge) {
      orderData['serviceCharge'] = merchantData.dining_service_charge;
    }
    return { ...orderDet, ...orderData };
  }

  const printKOT = (order) => {

    let printDetails = JSON.parse(JSON.stringify(order));
    console.log(printDetails);
    let kitchensUsed = [];
    let filterKitchenUsed = order?.orderItems.map((item, index) => {
      if (item.kitchenId && kitchensUsed.indexOf(item.kitchenId) == -1) {
        kitchensUsed.push(item.kitchenId);
      }
    });

    if (kitchensUsed.length) {
      let kitchPrintIndx = 0;
      let kitchPrintTimer = null;

      function sendForKOTPrint() {
        if (kitchPrintIndx >= kitchensUsed.length) {
          clearTimeout(kitchPrintTimer);
          kitchPrintIndx = 0; // Reset for next time (optional)
          return;
        }
        printDetails.printType = "KOT";
        let isAndroid = false;
        if (window.PrintInterface) {
          isAndroid = true;
          window.PrintInterface.print(JSON.stringify(printDetails));

        }
        if (!isAndroid && window?.chrome?.webview?.postMessage) {
          window.chrome.webview.postMessage(printDetails);
        }

        kitchPrintIndx++;
        kitchPrintTimer = setTimeout(sendForKOTPrint, 15 * 1000);
      }

      sendForKOTPrint();
    } else {
      printDetails.printType = "KOT";
      let isAndroid = false;
      if (window.PrintInterface) {
        isAndroid = true;
        window.PrintInterface.print(JSON.stringify(printDetails));
      }
      if (!isAndroid && window?.chrome?.webview?.postMessage) {
        window.chrome.webview.postMessage(printDetails);
      }
    }

  }

  const handlePrint = (order) => {
    if (window.PrintInterface || window?.chrome?.webview?.postMessage) {
      //if (true) {
      let ord = getOrderPrintDetails();
      ord.invoiceNo = ord.invoice_path || ord.invoicePath || ord.invoice_no || ord.invoiceNo || ord.number;
      ord.receiptNote = merchantData.receiptNotes || "";
      ord.cashOut = ord.cashOut || 0;
      ord.isPaid = ord.isPaid || "Unpaid";
      ord.customer = ord.customerName ? ("Name: " + ord.customerName + " ,Ph.:" + ord.customerPhone + ",Add.: " + ord.customerAddress) : (ord.customer && typeof ord.customer === 'object' ? ("Name: " + ord.customer?.firstName + " ,Ph.:" + ord.customer?.phone + ",Add.: " + ord.customer?.address) : (ord.customerInfo ? ("Name: " + (ord.customerInfo.name || ord.customerInfo.firstName) + " Phone: " + ord.customerInfo.phone + " Email: " + ord.customerInfo.email + " Address: " + ord.customerInfo.address) : ""));

      //ord.orderItems = oItems;
      //console.log(ord);
      printReceipt(ord, merchantData, [], t, formatter);
      setPrintOrder(null);
      //if(true){
      // setStartBillPrint(true);
      // localStorage.setItem("isPrintCall", "N");
    } else {
      localStorage.setItem("billing", true);
      summaryPath1(order);
    }
  };

  function summaryPath1(orderDetails) {
    console.log(orderDetails);
    const fullName = merchantData?.firstName || userData?.name || "";

    if (orderDetails) {
      window.location.href = `${window.location.origin
        }/billPrint?serve_url=${baseURL}&orderId=${orderDetails ? orderDetails.id : ""
        }&merchantCode=${merchCode ? merchCode : ""}&currency=${currency.length && currency[0].abbreviation
        }&restaurant=${fullName}&address=${userData || merchantData ? merchantData.address || userData.address : ""
        }&cgst=${merchantData.taxPerc}&invoice_no=${invoiceNo}&printType=${orderDetails.printType || "Order"
        }`;
    }
  }

  const handleWhatsAppClick = (order) => {
    let text = `*Order #${order.number}*\n`;
    if (order.merchantInfo && order.merchantInfo.name) {
      text += `*Store:* ${order.merchantInfo.name}\n`;
    }
    text += `*Type:* ${order.orderType}\n`;
    let currSymbol = currency && currency[0] ? currency[0].abbreviation : '';
    text += `*Amount:* ${(order.totalPrice || 0).toFixed(2)}\n`;
    text += `*Payment Status:* ${order.isPaid ? 'PAID' : 'PENDING'}\n`;
    text += `*Payment Mode:* ${order.paymentType || 'N/A'}\n`;

    if (order.customerInfo && (order.customerInfo.name || order.customerInfo.firstName || order.customerInfo.phone)) {
      text += `*Customer:* ${order.customerInfo.name || order.customerInfo.firstName || ''} ${order.customerInfo.phone || ''}\n`.trim() + '\n';
    }

    if (order.orderItems && order.orderItems.length) {
      text += `\n*Items:*\n`;
      order.orderItems.forEach((item, index) => {
        text += `${index + 1}. ${item.quantity}x ${item.name}`;
        text += `\n`;
      });
    }

    let url = `https://api.whatsapp.com/send?text=${encodeURIComponent(text)}`;
    if (order.merchantInfo && order.merchantInfo.phone) {
      let phone = order.merchantInfo.phone.replace(/[^\d+]/g, '');
      url = `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(text)}`;
    }
    window.open(url, '_blank');
  };

  const handleNumberSearch = (e) => {
    let val = e.target.value;
    console.log(val);
    let fltOrder = orderList.filter((ord) => ord.number === parseInt(val));
    console.log(fltOrder);
    setOrderFilter(fltOrder);
    setIsSearch(val ? true : false);
  };

  const handleDate = (e) => {
    let val = e.target.value;

    let inputDate = moment(val, "YYYY-MM-DD");

    let fltOrder = totalOrders.filter((ord) => {
      let orderDate = moment(ord.createdAt).format("DD/MMM/YYYY");
      console.log(orderDate);
      console.log(inputDate.format("DD/MMM/YYYY"));
      return orderDate === inputDate.format("DD/MMM/YYYY");
    });

    setOrderFilter(fltOrder);
    setIsSearch(Boolean(val));
  };

  useEffect(() => {
    if (isSuperAdmin) {
      const allOrders = [...orderList, ...tempOrders, ...report];
      const uniqueMerchantIds = [...new Set(allOrders.map(o => o.userId).filter(Boolean))];

      // Removed bulk merchantsCache fetching as per need-basis requirement
    }
  }, [orderList, tempOrders, report, isSuperAdmin, authApi]);

  const displayedOrderList = isSuperAdmin && !showAllSuperAdminOrders ? orderList.filter(o => o.orderSource === "Online Order" || o.isEcomList) : orderList;
  const displayedReport = isSuperAdmin && !showAllSuperAdminOrders ? report.filter(o => o.orderSource === "Online Order" || o.isEcomList) : report;
  const displayedTempOrders = isSuperAdmin ? tempOrders.filter(o => o.orderSource === "Online Order") : tempOrders;

  const ListOrders = isSearch ? orderFilter : (displayedReport.length ? displayedReport : displayedOrderList);

  const handleSort = () => {
    setIsReversed(!isReversed);
  };

  const handleWaiterToken = () => {
    setWaiter(true);
  };

  const handleWaiterClose = () => {
    setWaiter(false);
    setKitchenView(false);
    fetchOrdersAndNoti();
    fetchTempOrders();
  };
  const iframeSrc = `https://signage-common-assets.s3.ap-south-1.amazonaws.com/plugins/waiter-token/tokens.html?serve_url=${baseURL}&merchantCode=${merchCode}`;

  const kitchenSrc = `https://signage-common-assets.s3.ap-south-1.amazonaws.com/plugins/kitchen-side-token/tokens.html?serve_url=${baseURL}&merchantCode=${merchCode}`;
  const filteredOrders = ListOrders;
  // Function to filter orders based on the selected date
  // const filteredOrders = ListOrders.filter((order) => {
  //   const dateToCompare = order.scheduleDate || order.createdAt;
  //   return (
  //     moment(dateToCompare).isSame(moment(selectedDate), "day") &&
  //     order.orderStatus?.toUpperCase() !== "REJECTED"
  //   );
  // });


  const acceptOrder = async (orderId) => {
    console.log("id for temp", orderId);
    try {
      const res = await axios.put(
        `${baseURL}/api/temporders/${orderId}`,
        { orderStatus: "ACCEPTED" },
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );
      console.log("Order accepted");
      handleRefresh();
      document.querySelector('#temp_ord_sound')?.pause();
    } catch (err) {
      console.error("Failed to accept order", err);
    }
  };

  const rejectOrder = async (orderId) => {
    console.log("id for temp", orderId);
    try {
      const res = await axios.put(
        `${baseURL}/api/temporders/${orderId}`,
        { orderStatus: "REJECTED" },
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );
      console.log("Order rejected:");
      handleRefresh();
      document.querySelector('#temp_ord_sound')?.pause();
    } catch (err) {
      console.error("Failed to reject order", err);
    }
  };

  const handleAssignDriverClick = (order) => {
    setSelectedOrderForDriver(order);
    setAssignPopupOpen(true);
  };

  const handleAssignServerClick = (order) => {
    setSelectedOrderForServer(order);
    setAssignPopupOpen(true);
  };

  const refund_tx = (payRefData) => {
    let transData = JSON.parse(payRefData);
    const merchantId = transData.userId;
    var refID = transData.reference_id;
    var amount = transData.total_amount;
    var regID = userData.firstName || userData.name;
    var merchID = merchantId;

    let data = { 'amount': amount, 'reference_id': refID, 'register_id': regID, 'merchant_id': merchID, pos_prints_receipt: true, cash_amount: transData.cash_amount };
    let queryStr = encodeQueryData(data);

    setPayConfirmDialog('https://vcloud.alt-payment.com/webint/refund/NextOrder?' + queryStr);
    // $('#myModal').modal('show');
  }

  const handleWaiterAssign = (waiter) => {
    axios.patch(`${baseURL}/api/orders/${selectedOrderForServer?.id}?merchantCode=${merchCode}`, {
      servedByMemeberId: waiter.id,
    });
    setSelectedOrderForServer(null);
    setAssignPopupOpen(false);
  }

  const handleDriverAssign = async (driver) => {
    console.log("Assigning Driver:", driver);
    console.log("to Order:", selectedOrderForDriver);

    const orderId = selectedOrderForDriver?.id;
    const merchantCode = merchCode;
    const deliveryPartnerId = driver.id;
    const deliveryPartnerCode = "RESTAURANT_OWN";
    console.log("driver", deliveryPartnerId, deliveryPartnerCode);
    const pickupAddress = { address: merchantData.address, location: merchantData.location, name: merchantData.firstName };
    try {
      //create driver details if not available
      //add api call here
      const createDriverResponse = await axios.post(
        `${baseURL}/api/delivery-drivers?merchantCode=${merchantCode}`,
        {
          userId: deliveryPartnerId,
          merchantCode: merchantCode,
          name: driver.firstName,
          phone: driver.phone,
          email: driver.email,
          vehicleType: "",
          vehicleNumber: "",
          isActive: true,
          isAvailable: true,
          currentLocation: { type: "Point", coordinates: [0.0, 0.0] },
          rating: 1,
          deliveryPartnerCode: "RESTAURANT_OWN",
          deviceToken: "",
          documents: []
        },
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            "Content-Type": "application/json",
          },
        }
      );


      //link order and delivery
      const createDeliveryResponse = await axios.post(
        `${baseURL}/api/orders/${orderId}/delivery?merchantCode=${merchantCode}`,
        {

        },
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      const deliveryId = createDeliveryResponse.data.id;
      console.log("Delivery created:", deliveryId);

      const assignDriverResponse = await axios.post(
        `${baseURL}/api/deliveries/${deliveryId}/assign`,
        {
          orderDeliveryId: deliveryId,
          driverId: createDriverResponse.data.id,
          status: "ASSIGNED",
          notes: `Assigned at ${new Date().toISOString()}`,
        },
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Driver assigned:", assignDriverResponse.data);

      axios.patch(`${baseURL}/api/orders/${selectedOrderForDriver?.id}?merchantCode=${merchCode}`, {
        orderStatus: "ASSIGNED",
      });
      setAssignPopupOpen(false);
    } catch (error) {
      console.error("Error assigning driver:", error?.response?.data || error.message);
      // console.(
      //   "Driver assignment failed: " +
      //   (error?.response?.data?.message || error.message)
      // );
    }
  };

  const openDeliveryDialog = (order) => {
    setSelectedDeliveryOrder(order);
    setIsDeliveryDialogOpen(true);
    if (order.deliveryDetails) {
      setDeliveryFormData({
        deliveryPartnerCode: order.deliveryDetails.deliveryPartnerCode || '',
        thirdPartyOrderId: order.deliveryDetails.thirdPartyOrderId || '',
        trackingId: order.deliveryDetails.trackingId || '',
        trackingUrl: order.deliveryDetails.trackingUrl || '',
        deliveryFee: order.deliveryDetails.deliveryFee || '',
        deliveryNotes: order.deliveryDetails.deliveryNotes || ''
      });
    } else {
      setDeliveryFormData({ deliveryPartnerCode: '', thirdPartyOrderId: '', trackingId: '', trackingUrl: '', deliveryFee: '', deliveryNotes: '' });
    }
    if (deliveryPartners.length === 0) {
      axios.get(`${baseURL}/api/delivery-partners?merchantCode=${merchCode}`)
        .then(res => setDeliveryPartners(res.data))
        .catch(err => console.error("Failed to fetch delivery partners", err));
    }
  };

  const handleSaveDeliveryDetails = () => {
    if (!selectedDeliveryOrder) return;
    const orderId = selectedDeliveryOrder.id || selectedDeliveryOrder._id;
    axios.post(`${baseURL}/api/orders/${orderId}/delivery`, deliveryFormData, {
      headers: { Authorization: `Bearer ${userToken}` }
    })
      .then(res => {
        setIsDeliveryDialogOpen(false);
        // Update local order lists with delivery details
        setOrderList(prev => prev.map(o => (o.id === orderId || o._id === orderId) ? { ...o, deliveryDetails: res.data } : o));
        if (typeof setTempOrders === "function") {
          setTempOrders(prev => prev.map(o => (o.id === orderId || o._id === orderId) ? { ...o, deliveryDetails: res.data } : o));
        }
        // Proceed with in-transit status update
        handleOrderStatus("intransit", orderId, selectedDeliveryOrder.isPaid, selectedDeliveryOrder);
        // Clear form
        setDeliveryFormData({ deliveryPartnerCode: '', thirdPartyOrderId: '', trackingId: '', trackingUrl: '', deliveryFee: '', deliveryNotes: '' });
      })
      .catch(err => {
        console.error("Failed to save delivery details", err);
        alert("Failed to save delivery details. Please try again.");
      });
  };

  return (
    <div className="container" style={{ padding: "10px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: "20px",
          alignItems: "center",
          flexWrap: "wrap",
          '@media (max-width: 768px)': {
            gap: "12px",
            justifyContent: "flex-start"
          },
          '@media (max-width: 480px)': {
            gap: "8px"
          }
        }}
      >
        {/* Search Button */}
        <IconButton
          variant="contained"
          color="success"
          className="refresh_btn"
          onClick={() => setSearchShow(!searchShow)}
          style={{
            height: "50px",
            width: "50px",
            '@media (max-width: 768px)': {
              height: "45px",
              width: "45px"
            },
            '@media (max-width: 480px)': {
              height: "40px",
              width: "40px"
            }
          }}
        >
          <SearchIcon
            style={{
              '@media (max-width: 480px)': {
                fontSize: "20px"
              }
            }}
          />
        </IconButton>

        {isSuperAdmin && (
          <FormControlLabel
            control={
              <Switch
                checked={showAllSuperAdminOrders}
                onChange={(e) => setShowAllSuperAdminOrders(e.target.checked)}
                color="primary"
              />
            }
            label={showAllSuperAdminOrders ? "All Orders" : "Online Only"}
            style={{ marginLeft: "10px", color: "#333", fontWeight: "bold" }}
          />
        )}

        {/* Search Input */}
        {searchShow && (
          <input
            type="text"
            className="search_input"
            onChange={handleNumberSearch}
            placeholder="Search"
            style={{
              borderBottom: "1px solid #000",
              '@media (max-width: 768px)': {
                flex: "1",
                minWidth: "150px"
              },
              '@media (max-width: 480px)': {
                minWidth: "120px",
                fontSize: "14px"
              }
            }}
          />
        )}

        {/* Date Picker */}
        {<IconButton
          variant="contained"
          color="success"
          className="refresh_btn"
          style={{
            height: "50px",
            width: "50px",
            position: "relative",
            '@media (max-width: 768px)': {
              height: "45px",
              width: "45px"
            },
            '@media (max-width: 480px)': {
              height: "40px",
              width: "40px"
            }
          }}
        >
          <CalendarTodayIcon
            className="icon"
            style={{
              fontSize: "1.5em",
              '@media (max-width: 480px)': {
                fontSize: "1.3em"
              }
            }}
          />
          <DatePicker
            selected={selectedDate}
            onChange={(date) => setSelectedDate(date)}
            customInput={
              <span style={{
                marginLeft: '-35px',
                fontSize: "16px",
                '@media (max-width: 480px)': {
                  fontSize: "14px",
                  marginLeft: '-30px'
                }
              }}>
                {selectedDate ? moment(selectedDate).format("DD") : ""}
              </span>
            }
          />
        </IconButton>}

        {/* Kitchen View Button */}
        {merchantData?.bizVertical === 'restaurant' && (
          <IconButton
            variant="contained"
            color="success"
            className="refresh_btn"
            onClick={() => setKitchenView(true)}
            style={{
              height: "50px",
              width: "50px",
              '@media (max-width: 768px)': {
                height: "45px",
                width: "45px"
              },
              '@media (max-width: 480px)': {
                height: "40px",
                width: "40px"
              }
            }}
          >
            <img
              src="/images/chef.gif"
              style={{
                width: "35px",
                height: "35px",
                objectFit: "contain",
                '@media (max-width: 480px)': {
                  width: "30px",
                  height: "30px"
                }
              }}
              alt=""
            />
          </IconButton>
        )}

        {/* Waiter Token Button */}
        {merchantData?.bizVertical === 'restaurant' && (
          <IconButton
            variant="contained"
            color="success"
            className="refresh_btn"
            onClick={() => handleWaiterToken()}
            style={{
              height: "50px",
              width: "50px",
              '@media (max-width: 768px)': {
                height: "45px",
                width: "45px"
              },
              '@media (max-width: 480px)': {
                height: "40px",
                width: "40px"
              }
            }}
          >
            <img
              src="/images/waiter.png"
              style={{
                width: "25px",
                height: "25px",
                objectFit: "contain",
                '@media (max-width: 480px)': {
                  width: "22px",
                  height: "22px"
                }
              }}
              alt=""
            />
          </IconButton>
        )}

        {/* Refresh Button */}
        <IconButton
          variant="contained"
          color="success"
          className="refresh_btn"
          onClick={handleRefresh}
          style={{
            height: "50px",
            width: "50px",
            '@media (max-width: 768px)': {
              height: "45px",
              width: "45px"
            },
            '@media (max-width: 480px)': {
              height: "40px",
              width: "40px"
            }
          }}
        >
          <RefreshIcon
            style={{
              '@media (max-width: 480px)': {
                fontSize: "20px"
              }
            }}
          />
        </IconButton>

        {/* View Toggle Button */}
        <div style={{
          display: 'flex',
          gap: '10px',
          alignItems: 'center',
          '@media (max-width: 768px)': {
            marginLeft: 'auto'
          }
        }}>
          <button
            onClick={() => setViewMode(viewMode === 'card' ? 'table' : 'card')}
            style={{
              padding: '12px',
              border: '1px solid white',
              background: viewMode === 'card' ? 'white' : 'rgb(61 106 4)',
              color: viewMode === 'card' ? 'rgb(61 106 4)' : 'white',
              borderRadius: '50%',
              cursor: 'pointer',
              fontWeight: 'bold',
              transition: 'all 0.3s ease',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: '40px',
              minHeight: '40px'
            }}
          >
            {viewMode === 'card' ? (
              <ListIcon
                sx={{
                  fontSize: '20px',
                  transition: 'transform 0.3s ease',
                  '@media (max-width: 480px)': {
                    fontSize: '18px'
                  }
                }}
              />
            ) : (
              <ViewModuleIcon
                sx={{
                  fontSize: '20px',
                  transition: 'transform 0.3s ease',
                  '@media (max-width: 480px)': {
                    fontSize: '18px'
                  }
                }}
              />
            )}
          </button>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          gap: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: "10px",
          }}
        >

          <div
            id="head"
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
              alignItems: "center",
              width: "auto",
            }}
          >
            {false && (
              <div id="group">
                <label htmlFor="">Date: </label>
                <input
                  type="date"
                  onChange={handleDate}
                  style={{
                    outline: "none",
                    borderRadius: "5px",
                    background: "transparent",
                  }}
                />
              </div>
            )}
            {false && (
              <span id="table_group">
                Table orders &nbsp;&nbsp;
                <FormControlLabel
                  control={<Switch color="info" />}
                  onChange={handleTableOrders}
                />{" "}
              </span>
            )}
          </div>
        </div>
      </div>

      {startBillPrint && (
        <BillPrint orderDetails={getOrderPrintDetails()} setBillPrint={setStartBillPrint} />
      )}

      <Dialog open={alertOpen} maxWidth="xs" fullWidth={true}>
        <div className="alert-dialog">
          <h3 className="">{"Payment Pending"}</h3>
          <button
            onClick={() => setAlertOpen(false)}
            className="btn btn-sm btn-primary"
            style={{
              width: "60px",
              padding: "10px 5px",
              margin: "auto",
              height: "40px",
            }}
          >
            OK
          </button>
        </div>
      </Dialog>

      {openDeleteDialog === true ? (
        <DeleteDiaologue
          msg="delete"
          open={openDeleteDialog}
          onClose={handleDeleteClose}
          onConfirm={handleConfirmDelete}
          itemName={deleteitemName}
        />
      ) : (
        <div />
      )}

      {openDeleteDialog === true ? (
        <DeleteDiaologue
          msg="Cancel Order"
          open={openDeleteDialog}
          onClose={handleCancelClose}
          onConfirm={handleConfirmCancel}
          itemName={deleteitemName}
        />
      ) : (
        <div />
      )}

      <Dialog
        open={openNotifi || props.notification}
        maxWidth="md"
        fullWidth={true}
      >
        <div className="alert-dialog">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span></span>
            <h3 className="">{"Notification"}</h3>
            <button
              style={{ border: "none", color: "red" }}
              onClick={handleClear}
            >
              Clear All{" "}
            </button>
          </div>
          <div style={{ overflowY: "scroll", height: "400px" }}>
            {notifiData.length
              ? notifiData.map((noti) => {
                return (
                  <div>
                    <p>
                      {noti.msg} on{" "}
                      {moment(`${noti.createdAt}`).format("DD MMM h:mm a")}{" "}
                    </p>
                  </div>
                );
              })
              : ""}
          </div>

          <Button
            variant="contained"
            color="error"
            style={{ float: "right", right: "10px" }}
            onClick={() => {
              setOpenNotifi(false);
              props.setNotification(false);
            }}
          >
            Close{" "}
          </Button>
        </div>
      </Dialog>

      <Dialog open={waiter || kitchenView} onClose={handleWaiterClose} fullScreen={true}>
        {/* <IconButton
          edge="start"
          color="error"
          variant="contained"
          onClick={handleWaiterClose}
          aria-label="close"
          style={{
            position: "fixed",
            right: 10,
            top: 10,
            zIndex: 1000,
            backgroundColor: "rgba(255, 255, 255, 0.8)",
          }}
        >
          <CloseIcon />
        </IconButton> */}
        <Button
          variant="contained"
          color="error"
          style={{ float: "right", marginTop: "5px" }}
          className="btn btn-danger m-2 btn-small"
          onClick={handleWaiterClose}
        >
          Close
        </Button>

        {waiter && <iframe
          src={iframeSrc}
          style={{ width: "100%", height: "100%", border: "none", zIndex: 1 }}
          title="Waiter Token"
        />}
        {
          kitchenView && <iframe
            src={kitchenSrc}
            style={{ width: "100%", height: "100%", border: "none", zIndex: 1 }}
            title="Kitchen Tokens"
          />
        }
      </Dialog>

      <div className="category-list" style={{ padding: "2px" }}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            paddingInline: "5px",
            gap: "5px",
          }}
        >

          {false && <div id="group">
            {false && <label>Group By: </label>}
            <span
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
              }}
            >
              <label>Order Type</label>
              <select
                onChange={handleTypeOrder}
                style={{
                  outline: "none",
                  borderRadius: "5px",
                  background: "transparent",
                }}
              >
                <option value="">ALL</option>
                <option value="Eat In">Eat In Orders</option>
                <option value="Take Away">Take Away Orders</option>
                <option value="Table Order">Table Orders</option>
                <option value="Delivery">Delivery Orders</option>
              </select>
            </span>
          </div>}
        </div>
        <div>

          {/* Pending Orders */}
          {displayedTempOrders.length > 0 &&
            displayedTempOrders.filter(
              (order) =>
                (order.orderStatus === "PENDING" || order.orderStatus === "NEW") && order.paymentType && order.orderType
            ).length > 0 &&
            <div>
              {/* Temp Order Filter Buttons */}
              <div style={{
                display: 'flex',
                gap: '12px',
                marginBottom: '16px',
                overflowX: 'auto',
                flexWrap: 'wrap',
                paddingBottom: '8px',
                scrollbarWidth: 'thin',
                WebkitOverflowScrolling: 'touch',
                justifyContent: 'center',
                marginTop: "10px"
              }}>
                <Button
                  variant={tempOrderFilterType === 'now' ? 'contained' : 'outlined'}
                  color="primary"
                  onClick={() => setTempOrderFilterType('now')}
                  style={{
                    minWidth: '120px',
                    fontWeight: '600',
                    fontSize: '14px',
                    whiteSpace: 'nowrap'
                  }}
                >
                  NEW ORDERS ({displayedTempOrders.filter((order) =>
                    (order.orderStatus === "PENDING" || order.orderStatus === "NEW") && order.paymentType && order.orderType && !order.scheduleDate
                  ).length})
                </Button>
                <Button
                  variant={tempOrderFilterType === 'scheduled' ? 'contained' : 'outlined'}
                  color="info"
                  onClick={() => setTempOrderFilterType('scheduled')}
                  style={{
                    minWidth: '120px',
                    fontWeight: '600',
                    fontSize: '14px',
                    whiteSpace: 'nowrap'
                  }}
                >
                  Scheduled ({displayedTempOrders.filter((order) =>
                    (order.orderStatus === "PENDING" || order.orderStatus === "NEW") && order.paymentType && order.orderType && order.scheduleDate && moment(order.scheduleDate).isAfter(moment())
                  ).length})
                </Button>
              </div>
              <div className="tempOrder">
                <Table breakPoint={700} className="custom-table">
                  <Thead>
                    <Tr className="table-header">
                      <Th>#Token</Th>
                      <Th>Merchant</Th>
                      <Th>Order Type</Th>
                      <Th>Source</Th>
                      <Th>Amount(Inc tax)</Th>
                      <Th>Order Items</Th>
                      <Th>Actions</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {displayedTempOrders
                      .filter(
                        (order) =>
                          (order.orderStatus === "PENDING" || order.orderStatus === "NEW") && order.paymentType && order.orderType
                      )
                      .filter((order) => {
                        if (tempOrderFilterType === 'now' && !order.scheduleDate) return true;
                        if (tempOrderFilterType === 'scheduled') {
                          return order.scheduleDate && moment(order.scheduleDate).isAfter(moment());
                          return true;
                        }

                      })
                      .map((order) => (
                        <Tr key={order.id || order._id} className="table-body-row">
                          <Td style={{ fontSize: "20px", fontWeight: "bold", color: "#4d4a4a" }}>
                            {order.number || 'N/A'}
                          </Td>
                          <Td>
                            {isSuperAdmin ? (
                              <div>
                                <div style={{ fontWeight: 'bold' }}>{merchantsCache[order.userId]?.firstName || 'Loading...'}</div>
                                <div style={{ fontSize: '12px', color: '#666' }}>ID: {order.userId}</div>
                                <div style={{ fontSize: '12px', color: '#666' }}>{merchantsCache[order.userId]?.phone || 'N/A'}</div>
                              </div>
                            ) : (
                              order.userId
                            )}
                          </Td>
                          <Td>
                            {(order.orderType.toLowerCase() === "pick up" ||
                              order.orderType.toLowerCase() === "take away") && (
                                <img
                                  height="40px"
                                  width="40px"
                                  alt=""
                                  src="/images/take-out-2.png"
                                />
                              )}
                            {order.orderType.toLowerCase() === "delivery" && (
                              <img
                                height="40px"
                                width="40px"
                                alt=""
                                src="/images/delivery.png"
                              />
                            )}
                          </Td>
                          <Td>
                            <Chip
                              label={order.orderSource || "Self Order"}
                              color={
                                (order.orderSource || "Self Order") === "EPOS"
                                  ? "info"
                                  : (order.orderSource || "Self Order") === "Self Order"
                                    ? "warning"
                                    : (order.orderSource || "Self Order") === "Table Order"
                                      ? "secondary"
                                      : (order.orderSource || "Self Order") === "Online Order"
                                        ? "error"
                                        : "default"
                              }
                              style={{
                                marginLeft: "10px",
                                fontSize: "x-small",
                                fontWeight: "bold",
                              }}
                            />
                            <div style={{ fontSize: "12px" }}>
                              {moment(order.scheduleDate || order.createdAt).format("DD-MMM h:mm a")}
                            </div>
                          </Td>
                          <Td>
                            {selectedCurrency}
                            {(order.discountType
                              ? order.discountType === "discount" || order.discountType === "price"
                                ? order.totalPrice - (order.discountAmount || 0)
                                : order.totalPrice - (order.totalPrice * order.discountAmount) / 100
                              : order.totalPrice
                            ).toFixed(2)}
                            {!order.isPaid ? (
                              <Chip
                                label="PENDING"
                                style={{
                                  fontSize: "x-small",
                                  fontWeight: "bold",
                                  background: "#fdd564",
                                  color: "#6f650e",
                                }}
                              />
                            ) : (
                              <Chip
                                label="✔ PAID"
                                color="success"
                                style={{
                                  fontSize: "x-small",
                                  fontWeight: "bold",
                                }}
                              />
                            )}
                          </Td>
                          <Td style={{ fontSize: "12px" }}>
                            <button
                              className="btn-icon"
                              onClick={() =>
                                tempOrderListHandler(
                                  order.id || order._id,
                                  order.customerId,
                                  order
                                )
                              }
                            >
                              <ReceiptLongOutlinedIcon />
                            </button>
                          </Td>
                          <Td>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                gap: "30px",
                              }}
                            >
                              <Button
                                variant="outlined"
                                color="error"
                                onClick={() => {
                                  setTempOrderToRejectId(order.id || order._id);
                                  setConfirmRejectTempOrder(true);
                                }}
                              >
                                <CloseIcon fontSize="small" />
                              </Button>
                              <Button
                                variant="contained"
                                color="success"
                                onClick={() => acceptOrder(order.id || order._id)}
                              >
                                Accept
                              </Button>
                            </div>
                          </Td>
                        </Tr>
                      ))}
                  </Tbody>
                </Table>
              </div>

            </div>
          }

          <br />

          {/* Main Orders */}
          <div >
            {/* Filter Buttons */}
            {merchantData?.bizVertical === 'restaurant' && (
              <div style={{
                display: 'flex',
                gap: '12px',
                marginBottom: '20px',
                overflowX: 'auto',
                flexWrap: 'wrap',
                paddingBottom: '8px',
                scrollbarWidth: 'thin',
                WebkitOverflowScrolling: 'touch',
                justifyContent: 'center'
              }}>

                <Button
                  variant={orderFilterType === 'preparing' ? 'contained' : 'outlined'}
                  color="warning"
                  onClick={() => setOrderFilterType('preparing')}
                  style={{
                    minWidth: '120px',
                    fontWeight: '600',
                    fontSize: '14px',
                    whiteSpace: 'nowrap'
                  }}
                >
                  Preparing ({filteredOrders.filter(orderLists => {
                    if (orderLists.isCanceled || orderLists.orderStatus?.toLowerCase() === "rejected") return false;
                    const totalItems = orderLists.orderItems?.length || 0;
                    if (totalItems === 0) return true;
                    const hasPreparing = orderLists.orderItems?.some(item => !item.status || (item.status !== 'ready' && item.status !== 'served' && item.status !== 'delivered'));
                    const allDelivered = orderLists.orderItems?.every(item => item.status === 'served' || item.status === 'delivered');
                    return hasPreparing && !allDelivered && !orderLists.isDelivered;
                  }).length})
                </Button>
                <Button
                  variant={orderFilterType === 'ready' ? 'contained' : 'outlined'}
                  color="success"
                  onClick={() => setOrderFilterType('ready')}
                  style={{
                    minWidth: '140px',
                    fontWeight: '600',
                    fontSize: '14px',
                    whiteSpace: 'nowrap'
                  }}
                >
                  Ready ({filteredOrders.filter(orderLists => {
                    if (orderLists.isCanceled || orderLists.orderStatus?.toLowerCase() === "rejected") return false;
                    const totalItems = orderLists.orderItems?.length || 0;
                    if (totalItems === 0) return true;
                    const hasPreparing = orderLists.orderItems?.some(item => !item.status || (item.status !== 'ready' && item.status !== 'served' && item.status !== 'delivered'));
                    const allDelivered = orderLists.orderItems?.every(item => item.status === 'served' || item.status === 'delivered');
                    return !hasPreparing && !allDelivered && !orderLists.isDelivered;
                  }).length})
                </Button>

                <Button
                  variant={orderFilterType === 'delivered' ? 'contained' : 'outlined'}
                  color="success"
                  onClick={() => setOrderFilterType('delivered')}
                  style={{
                    minWidth: '140px',
                    fontWeight: '600',
                    fontSize: '14px',
                    whiteSpace: 'nowrap'
                  }}
                >
                  COMPLETED ({filteredOrders.filter(orderLists => {
                    if (orderLists.isCanceled || orderLists.orderStatus?.toLowerCase() === "rejected") return false;
                    const totalItems = orderLists.orderItems?.length || 0;
                    if (totalItems === 0) return true;
                    const allDelivered = orderLists.orderItems?.every(item => item.status === 'served' || item.status === 'delivered');
                    return allDelivered || orderLists.isDelivered || orderLists.orderStatus?.toLowerCase() === "completed";
                  }).length})
                </Button>

                <Button
                  variant={orderFilterType === 'canceled' ? 'contained' : 'outlined'}
                  color="error"
                  onClick={() => setOrderFilterType('canceled')}
                  style={{
                    minWidth: '140px',
                    fontWeight: '600',
                    fontSize: '14px',
                    whiteSpace: 'nowrap'
                  }}
                >
                  CANCELLED ({filteredOrders.filter(orderLists => {
                    return orderLists.isCanceled || orderLists.orderStatus?.toLowerCase() === "rejected";
                  }).length})
                </Button>
              </div>
            )}
            {viewMode === 'card' ? (
              // Card View for Main Orders
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
                gap: '20px'
              }}>
                {filteredOrders.length ? (
                  (isReversed ? filteredOrders.slice().reverse() : filteredOrders)
                    .filter((orderLists) => {
                      if (orderFilterType === 'all') return true;

                      const totalItems = orderLists.orderItems?.length || 0;
                      if (totalItems === 0) return true;

                      const hasPreparing = orderLists.orderItems?.some(item => !item.status || (item.status !== 'ready' && item.status !== 'served' && item.status !== 'delivered'));
                      const allDelivered = orderLists.orderItems?.every(item => item.status === 'served' || item.status === 'delivered');

                      if (orderFilterType === 'preparing') {
                        return hasPreparing && !allDelivered && !orderLists.isDelivered && !orderLists.isCanceled && orderLists.orderStatus?.toLowerCase() !== "rejected";
                      }
                      if (orderFilterType === 'ready') {
                        return !hasPreparing && !allDelivered && !orderLists.isDelivered && !orderLists.isCanceled && orderLists.orderStatus?.toLowerCase() !== "rejected";
                      }
                      if (orderFilterType === 'delivered') {
                        return (allDelivered || orderLists.isDelivered || orderLists.orderStatus?.toLowerCase() === "completed") && !orderLists.isCanceled && orderLists.orderStatus?.toLowerCase() !== "rejected";
                      }
                      if (orderFilterType === 'canceled') {
                        return orderLists.isCanceled || orderLists.orderStatus?.toLowerCase() === "rejected";
                      }
                      return true;
                    })
                    .map((orderLists) => {
                      let paidStaus = notifiData.filter((nof) => orderLists.number === nof.token);
                      let payStatus = paidStaus.length ? true : false;
                      let tableCall = false;

                      if (orderLists.orderSource === "Table Order") {
                        const table = tableData && tableData.filter((tab) => tab.number == orderLists.number);
                        tableCall = table ? table[0] ? table[0].isServiceCall : "" : "";
                      }

                      // Calculate served/delivered items count
                      const totalItems = orderLists.orderItems?.length || 0;
                      const servedItems = orderLists.orderItems?.filter(item =>
                        item.status === "served" || item.status === "delivered"
                      ).length || 0;
                      const allServed = totalItems > 0 && servedItems === totalItems;


                      const getHeaderColor = (type) => {
                        const t = type?.toLowerCase() || '';
                        if (t === 'eat in') return '#e3f2fd'; // Light Blue
                        if (t === 'take away' || t === 'pick up') return '#fff3e0'; // Light Orange
                        if (t === 'table order') return '#e8f5e9'; // Light Green
                        if (t === 'delivery') return '#f3e5f5'; // Light Purple
                        return '#f8f9fa'; // Default
                      };

                      return (
                        <div
                          key={orderLists.id}
                          style={{
                            border: '1px solid #e0e0e0',
                            borderRadius: '12px',
                            padding: '20px',
                            background: orderLists.isCanceled ? '#fbe3e3cc' : '#fff',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                            transition: 'all 0.3s ease',
                            display: 'flex',
                            flexDirection: 'column'
                          }}
                        >
                          {/* Top Header Section */}
                          <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            marginBottom: '10px',
                            flexShrink: 0,
                            padding: '12px 20px',
                            margin: '-20px -20px 15px -20px',
                            borderTopLeftRadius: '11px',
                            borderTopRightRadius: '11px',
                            backgroundColor: orderLists.isCanceled ? '#f8d7da' : getHeaderColor(orderLists.orderType),
                            borderBottom: '1px solid #e0e0e0',
                            '@media (max-width: 768px)': {
                              flexDirection: 'column',
                              gap: '12px'
                            }
                          }}>
                            {/* Left Side */}
                            <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '12px',
                              flex: 1
                            }}>
                              {/* Order Type Icon */}


                              <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                gap: '2px',

                              }}>
                                {/* Order Number */}
                                <div style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '4px',
                                  fontSize: '25px',
                                  fontWeight: 'bold',
                                  color: '#4d4a4a',
                                  lineHeight: '1'
                                }}>
                                  #{orderLists.number}
                                  <div>
                                    {orderLists.orderType.toLowerCase() === "eat in" && (
                                      <img
                                        height="35px"
                                        alt="Eat In"
                                        width="35px"
                                        src="/images/eat_in.png"
                                      />
                                    )}
                                    {(orderLists.orderType.toLowerCase() === "take away" ||
                                      orderLists.orderType.toLowerCase() === "pick up") && (
                                        <img
                                          height="35px"
                                          width="35px"
                                          alt="Take Away"
                                          src="/images/take-out-2.png"
                                        />
                                      )}
                                    {orderLists.orderType === "Table Order" && (
                                      <img
                                        height="35px"
                                        width="35px"
                                        alt="Table Order"
                                        src="/images/tableOrder.png"
                                      />
                                    )}
                                    {orderLists.orderType.toLowerCase() === "delivery" && (
                                      <img
                                        height="35px"
                                        alt="Delivery"
                                        width="35px"
                                        src={require("../assets/img/delivery_scooter.png")}
                                      />
                                    )}
                                  </div>
                                  {tableCall && (
                                    <span style={{
                                      display: 'inline-block',
                                      animation: orderLists.isDelivered ? 'none' : 'shake 0.5s ease-in-out infinite'
                                    }}>
                                      <NotificationsActiveIcon sx={{
                                        color: "red",
                                      }} fontSize="small" />
                                    </span>
                                  )}
                                </div>

                                <div style={{
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  color: '#606060',
                                  lineHeight: '1',
                                  textAlign: "left"
                                }}>
                                  {orderLists.orderType}
                                </div>
                                {orderLists.orderTakenById ? (
                                  <span style={{
                                    fontSize: "12px",
                                    padding: '2px',
                                    textAlign: 'left'
                                  }}>
                                    Cashier: <b>{userData.sub == orderLists.orderTakenById ? userData.firstName : members.length ? members.filter(mb => (mb.id || mb.sub || mb._id) == orderLists.orderTakenById)[0]?.firstName : userData.firstName}</b>
                                  </span>
                                ) : ""}

                              </div>
                            </div>

                            {/* Right Side  */}
                            <div style={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'flex-end',
                              gap: '6px',
                              textAlign: 'right',
                              '@media (max-width: 768px)': {
                                alignItems: 'flex-start',
                                textAlign: 'left'
                              }
                            }}>
                              {/* Payment Status */}
                              {!orderLists.isPaid ? (
                                <span><Chip
                                  label={"Unpaid /" + orderLists.paymentType}
                                  style={{
                                    fontSize: "x-small",
                                    fontWeight: "bold",
                                    background: "#fdd564",
                                    color: "#6f650e",
                                  }}
                                /></span>
                              ) : (
                                <Chip
                                  label="✔ PAID"
                                  color="success"
                                  style={{
                                    fontSize: "x-small",
                                    fontWeight: "bold",
                                  }}
                                />
                              )}
                              <div style={{
                                fontSize: "12px",
                                color: '#666',
                              }}>
                                {orderLists?.payVia}
                              </div>
                              {/* Order Source */}
                              <div style={{
                                fontSize: "12px",
                                fontWeight: "bold",
                                color: '#1976d2',
                              }}>
                                {orderLists.orderSource || "Self Order"}
                              </div>

                              {/* Date & Time */}
                              <div style={{
                                fontSize: "12px",
                                color: '#666',
                              }}>
                                {moment(orderLists.scheduleDate || orderLists.createdAt).format("DD-MMM h:mm a")}
                              </div>

                            </div>
                          </div>

                          {/* Customer Address & Details */}

                          {((orderLists.customerInfo && (orderLists.customerInfo.firstName || orderLists.customerInfo.name || orderLists.customerInfo.phone || orderLists.customerInfo.email)) || orderLists.driverDetails || orderLists.customerId || isSuperAdmin) ? (
                            <div style={{
                              margin: '8px 0',
                              padding: '12px',
                              background: '#f0f8ff',
                              borderRadius: '8px',
                              border: '1px solid #d1e7ff',
                              flexShrink: 0
                            }}>
                              {/* Common Expand/Collapse Header */}
                              <div
                                onClick={() => {
                                  const isExpanding = infoExpanded[orderLists._id] !== true;
                                  setInfoExpanded(prev => ({
                                    ...prev,
                                    [orderLists._id]: !prev[orderLists._id]
                                  }));

                                  if (isExpanding) {
                                    const targetId = orderLists.id || orderLists._id;

                                    // Fetch Customer Info
                                    if (!orderLists.customerInfo && orderLists.customerId) {
                                      axios.get(`${authApi}/customer/${orderLists.customerId}`)
                                        .then(response => {
                                          let cData = response.data;
                                          if (Array.isArray(cData)) cData = cData[0] || {};
                                          else if (cData && cData.data) cData = cData.data;
                                          else if (cData && cData.customer) cData = cData.customer;

                                          const updateFn = prevList => prevList.map(order =>
                                            ((order.id && order.id === targetId) || (order._id && order._id === targetId))
                                              ? { ...order, customerInfo: cData }
                                              : order
                                          );
                                          setOrderList(updateFn);
                                          setReport(updateFn);
                                          setOrderFilter(updateFn);
                                          if (typeof setTempOrders === "function") setTempOrders(updateFn);
                                        }).catch(err => console.log("Customer fetch error", err));
                                    }

                                    // Fetch Merchant Info for SuperAdmin
                                    if (canViewMerchantDetails && !orderLists.merchantInfo && orderLists.userId) {
                                      axios.get(`${baseURL}/api/settings/merchants/${orderLists.userId}/open`)
                                        .then(response => {
                                          let mData = response.data;
                                          if (Array.isArray(mData)) mData = mData[0] || {};

                                          const updateFn = prevList => prevList.map(order =>
                                            ((order.id && order.id === targetId) || (order._id && order._id === targetId))
                                              ? { ...order, merchantInfo: mData }
                                              : order
                                          );
                                          setOrderList(updateFn);
                                          setReport(updateFn);
                                          setOrderFilter(updateFn);
                                          if (typeof setTempOrders === "function") setTempOrders(updateFn);
                                        }).catch(err => console.log("Merchant fetch error", err));
                                    }

                                    // Fetch Delivery Info
                                    if (orderLists.orderType?.toLowerCase() === "delivery" && (!orderLists.deliveryDetails || !orderLists.driverDetails)) {
                                      axios.get(`${baseURL}/api/orders/${targetId}/delivery`, {
                                        headers: { Authorization: `Bearer ${userToken}` }
                                      }).then(response => {
                                        const updatedData = response.data;
                                        const updateFn = prevList => prevList.map(order =>
                                          ((order.id && order.id === targetId) || (order._id && order._id === targetId))
                                            ? { ...order, deliveryDetails: updatedData.deliveryDetails, driverDetails: updatedData.driverDetails }
                                            : order
                                        );
                                        setOrderList(updateFn);
                                        setReport(updateFn);
                                        setOrderFilter(updateFn);
                                        if (typeof setTempOrders === "function") setTempOrders(updateFn);
                                      }).catch(err => console.log("Delivery fetch error", err));
                                    }
                                  }
                                }}
                                style={{
                                  fontSize: '13px',
                                  fontWeight: 'bold',
                                  color: '#1976d2',
                                  marginBottom: '8px',
                                  cursor: 'pointer',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '4px',
                                  borderBottom: '1px solid #d1e7ff',
                                  paddingBottom: '4px'
                                }}
                              >
                                {infoExpanded[orderLists._id] === true ? <ExpandLessIcon style={{ fontSize: '16px' }} /> : <ExpandMoreIcon style={{ fontSize: '16px' }} />}
                                More Information
                              </div>

                              <Collapse in={infoExpanded[orderLists._id] === true}>
                                <div>
                                  {/* Customer Info */}
                                  {orderLists.customerInfo && (orderLists.customerInfo.firstName || orderLists.customerInfo.name || orderLists.customerInfo.phone || orderLists.customerInfo.email) && (
                                    <div style={{ marginBottom: orderLists.driverDetails ? '8px' : '0' }}>
                                      <div style={{
                                        fontSize: '13px',
                                        fontWeight: 'bold',
                                        color: '#1976d2',
                                        marginBottom: '4px'
                                      }}>
                                        Customer
                                      </div>
                                      <div style={{ fontSize: '12px', color: '#555', paddingLeft: '12px' }}>
                                        <b>Name:</b>{` ${orderLists.customerInfo.firstName || orderLists.customerInfo.name || ''} ${orderLists.customerInfo.lastName || ''} `}
                                        <b>Phone:</b>
                                        {` ${orderLists.customerInfo.phone} `}
                                        <b>Email:</b>{` ${orderLists.customerInfo.email} `}
                                        <b>Address: </b>{` ${orderLists.customerInfo.address} `}
                                      </div>
                                    </div>
                                  )}

                                  {!orderLists.customerInfo && orderLists.customerId && (
                                    <div style={{ marginBottom: orderLists.driverDetails ? '8px' : '0' }}>
                                      <div style={{
                                        fontSize: '13px',
                                        fontWeight: 'bold',
                                        color: '#1976d2',
                                        marginBottom: '4px'
                                      }}>
                                        Customer
                                      </div>
                                      <div style={{ fontSize: '11px', color: '#666', fontStyle: 'italic', paddingLeft: '12px' }}>
                                        Loading details...
                                      </div>
                                    </div>
                                  )}

                                  {/* Merchant Details (SuperAdmin only) */}
                                  {canViewMerchantDetails && orderLists.merchantInfo && (
                                    <div style={{ marginBottom: orderLists.driverDetails ? '8px' : '0', marginTop: '8px' }}>
                                      <div style={{
                                        fontSize: '13px',
                                        fontWeight: 'bold',
                                        color: '#ff9800',
                                        marginBottom: '4px',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                      }}>
                                        <span>Merchant</span>
                                        {(orderLists.orderSource === "Online Order" || orderLists.isEcomList) && (
                                          <Button
                                            variant="outlined"
                                            color="success"
                                            size="small"
                                            onClick={() => handleWhatsAppClick(orderLists)}
                                            startIcon={<WhatsAppIcon />}
                                            style={{
                                              fontWeight: '500',
                                              minWidth: '90px',
                                              fontSize: '0.65rem',
                                              height: '24px',
                                              padding: '2px 6px'
                                            }}
                                          >
                                            WhatsApp
                                          </Button>
                                        )}
                                      </div>
                                      <div style={{ fontSize: '12px', color: '#555', paddingLeft: '12px' }}>
                                        <b>Name:</b>{` ${orderLists.merchantInfo.firstName || ''} ${orderLists.merchantInfo.lastName || ''} `}
                                        <b>Code:</b>{` ${orderLists.merchantInfo.merchantCode || orderLists.userId} `}
                                        <b>Phone:</b>{` ${orderLists.merchantInfo.phone || 'N/A'} `}
                                      </div>
                                    </div>
                                  )}

                                  {canViewMerchantDetails && !orderLists.merchantInfo && orderLists.userId && (
                                    <div style={{ marginBottom: orderLists.driverDetails ? '8px' : '0', marginTop: '8px' }}>
                                      <div style={{
                                        fontSize: '13px',
                                        fontWeight: 'bold',
                                        color: '#ff9800',
                                        marginBottom: '4px'
                                      }}>
                                        Merchant
                                      </div>
                                      <div style={{ fontSize: '11px', color: '#666', fontStyle: 'italic', paddingLeft: '12px' }}>
                                        Loading details...
                                      </div>
                                    </div>
                                  )}

                                  {/* Driver Details */}
                                  {orderLists.driverDetails && (
                                    <div>
                                      <div style={{
                                        fontSize: '13px',
                                        fontWeight: 'bold',
                                        color: '#d32f2f',
                                        marginBottom: '4px'
                                      }}>
                                        Driver
                                      </div>
                                      <div style={{ fontSize: '12px', color: '#555', paddingLeft: '12px' }}>
                                        <b>Name: </b>{` ${orderLists.driverDetails.name}`} <b>Phone:</b>{` ${orderLists.driverDetails.phone}`} <b>Note:</b> {` ${orderLists.driverDetails.notes} `}
                                        <b>Delivery Status:</b> {orderLists.deliveryDetails.driverAssignments.filter(OrdDel => OrdDel.orderDeliveryId == orderLists.deliveryDetails._id)[0].status}
                                      </div>
                                    </div>
                                  )}

                                  {/* Delivery Details */}
                                  {orderLists.deliveryDetails && (
                                    <div>
                                      <div style={{
                                        fontSize: '13px',
                                        fontWeight: 'bold',
                                        color: '#d32f2f',
                                        marginBottom: '4px',
                                        marginTop: '4px'
                                      }}>
                                        Delivery Details
                                      </div>
                                      <div style={{ fontSize: '12px', color: '#555', paddingLeft: '12px' }}>
                                        {orderLists.deliveryDetails.deliveryPartnerCode && <><span style={{ fontWeight: 600 }}>Partner:</span> {orderLists.deliveryDetails.deliveryPartnerCode} <br /></>}
                                        {orderLists.deliveryDetails.trackingId && <><span style={{ fontWeight: 600 }}>Tracking ID:</span> {orderLists.deliveryDetails.trackingId} <br /></>}
                                        {orderLists.deliveryDetails.trackingUrl && <><span style={{ fontWeight: 600 }}>Tracking URL:</span> <a href={orderLists.deliveryDetails.trackingUrl} target="_blank" rel="noreferrer" style={{ color: '#1976d2' }}>{orderLists.deliveryDetails.trackingUrl}</a> <br /></>}
                                        {orderLists.deliveryDetails.thirdPartyOrderId && <><span style={{ fontWeight: 600 }}>Third Party ID:</span> {orderLists.deliveryDetails.thirdPartyOrderId} <br /></>}
                                        {orderLists.deliveryDetails.deliveryFee !== undefined && orderLists.deliveryDetails.deliveryFee !== null && <><span style={{ fontWeight: 600 }}>Fee:</span> {orderLists.deliveryDetails.deliveryFee} <br /></>}
                                        {orderLists.deliveryDetails.deliveryNotes && <><span style={{ fontWeight: 600 }}>Notes:</span> {orderLists.deliveryDetails.deliveryNotes} <br /></>}
                                      </div>
                                    </div>
                                  )}

                                  {/* Delivery Image Proof */}
                                  {(() => {
                                    const rawPath = orderLists.deliveryImage;
                                    if (!rawPath) return null;
                                    const finalImageUrl = rawPath.startsWith('http') ? rawPath : `https://pub-7d018e78476f444b9b0ae266e4d5b295.r2.dev/deliveries/${rawPath}`;
                                    return (
                                      <div style={{ marginTop: '10px' }}>
                                        <div style={{
                                          fontSize: '13px',
                                          fontWeight: 'bold',
                                          color: '#2e7d32',
                                          marginBottom: '4px'
                                        }}>
                                          Delivery Photo Proof
                                        </div>
                                        <div style={{ paddingLeft: '12px' }}>
                                          <img
                                            src={finalImageUrl}
                                            alt="Delivery Proof"
                                            style={{
                                              width: '100px',
                                              height: '100px',
                                              objectFit: 'cover',
                                              borderRadius: '8px',
                                              border: '1px solid #ddd',
                                              cursor: 'pointer',
                                              boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                                              transition: 'transform 0.2s'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                            onClick={() => window.open(finalImageUrl, '_blank')}
                                          />
                                        </div>
                                      </div>
                                    );
                                  })()}
                                </div>
                              </Collapse>
                            </div>
                          ) : null}


                          {/* Order Items Section  */}
                          <div style={{
                            margin: '12px 0',
                            display: 'flex',
                            flexDirection: 'column'
                          }}>
                            <div style={{
                              display: 'flex',
                              flexDirection: 'column'
                            }}>
                              {/* Order Items Header with Served Items inline */}
                              <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '10px',
                                borderBottom: '1px solid #dee2e6',
                                flexShrink: 0,
                                paddingBottom: "5px"
                              }}>
                                <strong style={{
                                  fontSize: '15px',
                                }}>
                                  Items ({orderLists.orderItems?.length || 0})
                                </strong>

                                {/* Server Information */}
                                {orderLists.servedByMemeberId && members.length && (
                                  <span style={{
                                    fontSize: "12px",
                                    padding: '2px',
                                  }}>
                                    Serving: <b>{userData.sub == orderLists.servedByMemeberId ? userData.firstName : members.filter(mb => mb.id == orderLists.servedByMemeberId)[0]?.firstName}</b>
                                  </span>
                                )}

                                {!orderLists.isEcomList && ((totalItems > 0 && servedItems != totalItems) ? (
                                  <div style={{
                                    fontSize: "13px",
                                    fontWeight: "bold",
                                    color: '#e65100',
                                    padding: '4px 8px',
                                    borderRadius: '6px',
                                    display: 'inline-block'
                                  }}>
                                    {servedItems}/{totalItems} served
                                  </div>
                                ) : <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                  <Chip
                                    label="✔ DELIVERED"
                                    color="success"
                                    style={{
                                      fontSize: "x-small",
                                      fontWeight: "bold",
                                    }}
                                  />
                                </div>)}
                              </div>

                              {/* Items Container */}
                              <div style={{
                                paddingRight: '4px'
                              }}>
                                {orderLists.orderItems?.map((item, index) => {
                                  let orderItem = item;
                                  const subProArray =
                                    typeof orderItem.sub_pro === "string"
                                      ? JSON.parse(orderItem.sub_pro)
                                      : orderItem.sub_pro;

                                  const subProNames = Array.isArray(subProArray?.addons)
                                    ? subProArray.addons.map((subPro) => subPro.name)
                                    : [];

                                  const subProInstruction = Array.isArray(
                                    subProArray?.cookInstructions
                                  )
                                    ? subProArray.cookInstructions
                                    : [];

                                  const subProVariety =
                                    subProArray?.variety &&
                                      typeof subProArray.variety === "object"
                                      ? Object.keys(subProArray.variety)[0] || ""
                                      : "";

                                  return <div key={index} style={{
                                    marginBottom: '6px',
                                    fontSize: '14px',
                                    padding: '8px',
                                    background: '#fff',
                                    borderRadius: '6px',
                                    border: '1px solid #e9ecef',
                                  }}>
                                    <div style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'flex-start',
                                      marginBottom: '4px'

                                    }}>
                                      {/* Item Name  */}
                                      <span style={{
                                        flex: 1,
                                        fontWeight: 'normal',
                                        fontSize: '14px',
                                        textAlign: "left",
                                        lineHeight: '1.4',
                                      }}>
                                        {item.quantity}x {item.name}
                                      </span>
                                      <Chip
                                        label={subProVariety.toUpperCase()}
                                        color="warning"
                                        style={{
                                          marginLeft: "10px",
                                          fontSize: "10px",
                                          fontWeight: "bold",
                                        }}
                                      />
                                      {subProNames.length > 0 ? (
                                        <Chip
                                          label={subProNames.join(", ").toUpperCase()}
                                          color="default"
                                          style={{
                                            marginLeft: "10px",
                                            fontSize: "10px",
                                            fontWeight: "bold",
                                          }}
                                        />
                                      ) : (
                                        subProNames
                                      )}
                                      <Chip
                                        label={subProInstruction.join(", ").toUpperCase()}
                                        color="primary"
                                        style={{
                                          marginLeft: "10px",
                                          fontSize: "8px",
                                          fontWeight: "bold",
                                        }}
                                      />

                                      {item.appliedOfferDescription && (
                                        <Chip
                                          label={item.appliedOfferDescription.toUpperCase()}
                                          color="info"
                                          variant="outlined"
                                          style={{
                                            marginLeft: "10px",
                                            fontSize: "10px",
                                            fontWeight: "bold",
                                            borderColor: "#1976d2",
                                            color: "#1976d2"
                                          }}
                                        />
                                      )}
                                      {item.status === "ready" || item.status === "delivered" ? <Chip
                                        label="✔"
                                        color={item.status == "ready" ? "warning" : "success"}
                                        style={{
                                          fontSize: "15px!important",
                                          fontWeight: "bold",
                                        }}
                                      /> : (!orderLists.isEcomList && merchantData?.bizVertical === 'restaurant' && <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '4px',
                                        minWidth: '80px',
                                        justifyContent: 'flex-end',
                                        marginLeft: '8px',
                                      }}>
                                        <img
                                          src="./chef.gif"
                                          alt="In Progress"
                                          style={{
                                            width: '28px',
                                            height: '28px'
                                          }}
                                        />
                                      </div>)}
                                    </div>
                                  </div>
                                })}
                              </div>

                              {/* Total Section */}
                              <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                marginTop: '12px',
                                paddingTop: '12px',
                                borderTop: '2px solid #dee2e6',
                                fontWeight: 'bold',
                                fontSize: '15px',
                                flexShrink: 0,
                              }}>
                                <span>Total:</span>
                                <span> {formatter.format(orderLists.totalPrice).replace('JMD', 'J$')} </span>
                              </div>
                            </div>
                          </div>
                          {/* Action Buttons */}
                          <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '12px',
                            marginTop: '16px',
                            paddingTop: '16px',
                            borderTop: '1px solid #eee'
                          }}>
                            {/* Status Section */}


                            {/* First Row - Core Actions */}
                            <div style={{
                              display: 'flex',
                              gap: '13px',
                              alignItems: 'center',
                              flexWrap: 'wrap',
                              justifyContent: 'space-around'
                            }}>
                              <div style={{
                                display: 'flex',
                                gap: '13px',
                                alignItems: 'center',
                                flexWrap: 'wrap'
                              }}>
                                {!orderLists.isPaid && !orderLists.isCanceled && (
                                  <>
                                    <Button
                                      variant="outlined"
                                      color="primary"
                                      size="small"
                                      onClick={() => (setSelectedOrder(orderLists), handleUpdateOrder(orderLists))}
                                      startIcon={<EditIcon />}
                                      style={{
                                        fontWeight: '500',
                                        minWidth: '70px',
                                        fontSize: '0.7rem',
                                        height: '32px',
                                        padding: '4px 8px'
                                      }}
                                    >
                                      Edit
                                    </Button>

                                    <Button
                                      variant="contained"
                                      color="error"
                                      size="small"
                                      onClick={(e) => {
                                        setPayModeSelectDialog(true);
                                        setSelectedOrder(orderLists);
                                      }}
                                      style={{
                                        fontWeight: 'bold',
                                        minWidth: '85px',
                                        fontSize: '0.7rem',
                                        height: '32px',
                                        padding: '4px 8px'
                                      }}
                                    >
                                      Pay Now
                                    </Button>
                                  </>
                                )}

                                <Button
                                  variant="outlined"
                                  color="success"
                                  size="small"
                                  onClick={() => { handlecheckprint(orderLists) }}
                                  startIcon={<PrintIcon />}
                                  style={{
                                    fontWeight: '500',
                                    minWidth: '70px',
                                    fontSize: '0.7rem',
                                    height: '32px',
                                    padding: '4px 8px'
                                  }}
                                >
                                  Bill
                                </Button>

                                {!orderLists.isEcomList && merchantData?.bizVertical === "restaurant" && !orderLists.orderItems.every(item => item.status === "ready") && <Button
                                  variant="outlined"
                                  color="info"
                                  size="small"
                                  onClick={() => handlecheckprintKOT(orderLists)}
                                  startIcon={<PrintIcon />}
                                  style={{
                                    fontWeight: '500',
                                    minWidth: '90px',
                                    fontSize: '0.7rem',
                                    height: '32px',
                                    padding: '4px 8px'
                                  }}
                                >
                                  KOT
                                </Button>}
                              </div>

                              {/* Right Side  */}
                              <div style={{
                                display: 'flex',
                                gap: '10px',
                                alignItems: 'center',
                                flexWrap: 'wrap'
                              }}>
                                {/* Discount Button */}
                                {!orderLists.isPaid && !orderLists.isCanceled && (
                                  <Button
                                    variant="outlined"
                                    color="secondary"
                                    size="small"
                                    onClick={() => handleOpenPopup(orderLists)}
                                    startIcon={<DiscountIcon />}
                                    style={{
                                      fontWeight: '500',
                                      minWidth: '110px',
                                      fontSize: '0.7rem',
                                      height: '32px',
                                      padding: '4px 8px'
                                    }}
                                  >
                                    Discount
                                  </Button>
                                )}

                                {/* Cancel/Refund Button */}
                                {!userData?.isIAM && !orderLists.isDelivered && !orderLists.isCanceled && (
                                  <Button
                                    variant="outlined"
                                    color="error"
                                    size="small"
                                    onClick={() => handleCancel(orderLists.id || orderLists._id, orderLists.isCanceled, orderLists.tableId, orderLists.number)}
                                    startIcon={<CancelIcon />}
                                    style={{
                                      fontWeight: '500',
                                      minWidth: '85px',
                                      fontSize: '0.7rem',
                                      height: '32px',
                                      padding: '4px 8px'
                                    }}
                                  >
                                    {orderLists.isPaid ? "Refund" : "Cancel"}
                                  </Button>

                                )}
                                {orderLists.orderType === "Delivery" && orderLists.orderItems.every(item => item.status === "ready") && orderLists.orderStatus.toUpperCase() !== "ASSIGNED" && (
                                  <Button
                                    variant="outlined"
                                    color="success"
                                    size="small"
                                    onClick={() => handleAssignDriverClick(orderLists)}
                                    startIcon={<DeliveryDiningIcon />}
                                    style={{
                                      fontWeight: '500',
                                      minWidth: '115px',
                                      fontSize: '0.7rem',
                                      height: '32px',
                                      padding: '4px 8px'
                                    }}
                                  >
                                    Assign Driver
                                  </Button>
                                )}

                                {false && orderLists.orderType.toLowerCase() === "delivery" && !orderLists.isCanceled && (
                                  <>
                                    <input
                                      type="file"
                                      accept="image/*"
                                      capture="environment"
                                      style={{ display: "none" }}
                                      id={`capture-pic-input-${orderLists.id || orderLists._id}`}
                                      onChange={(e) => handleUploadDeliveryPic(e, orderLists.id || orderLists._id)}
                                    />
                                    <label htmlFor={`capture-pic-input-${orderLists.id || orderLists._id}`} style={{ margin: 0, cursor: 'pointer' }}>
                                      {(() => {
                                        const rawPath = orderLists.deliveryImage || orderLists.image || orderLists.imagePath || orderLists.proof;
                                        const finalImageUrl = rawPath ? (rawPath.startsWith('http') ? rawPath : `https://pub-7d018e78476f444b9b0ae266e4d5b295.r2.dev/deliveries/${rawPath}`) : null;
                                        return finalImageUrl ? (
                                          <img
                                            src={finalImageUrl}
                                            alt="Delivery Proof"
                                            style={{ height: '32px', width: '32px', objectFit: 'cover', borderRadius: '4px', verticalAlign: 'middle' }}
                                          />
                                        ) : (
                                          <Button
                                            variant="outlined"
                                            color="info"
                                            size="small"
                                            component="span"
                                            startIcon={<PhotoCameraIcon />}
                                            style={{
                                              fontWeight: '500',
                                              minWidth: '110px',
                                              fontSize: '0.7rem',
                                              height: '32px',
                                              padding: '4px 8px'
                                            }}
                                          >
                                            Packing Image
                                          </Button>
                                        );
                                      })()}
                                    </label>
                                  </>
                                )}

                                {false && (orderLists.orderType.toLowerCase() === "delivery" ||
                                  orderLists.orderType.toLowerCase() === "take away" ||
                                  orderLists.orderType.toLowerCase() === "pick up") && !orderLists.isCanceled && (
                                    <Button
                                      variant="outlined"
                                      color="primary"
                                      size="small"
                                      onClick={() => handlePrintLabel(orderLists)}
                                      startIcon={<PrintIcon />}
                                      style={{
                                        fontWeight: '500',
                                        minWidth: '100px',
                                        fontSize: '0.7rem',
                                        height: '32px',
                                        padding: '4px 8px'
                                      }}
                                    >
                                      Item Label
                                    </Button>
                                  )}

                                {orderLists.orderType === "Table Order" && (
                                  <Button
                                    variant="outlined"
                                    color="success"
                                    size="small"
                                    onClick={() => handleAssignServerClick(orderLists)}
                                    startIcon={<DinnerDining />}
                                    style={{
                                      fontWeight: '500',
                                      fontSize: '0.7rem',
                                      height: '32px',
                                      padding: '4px 8px'
                                    }}
                                  >
                                    Server
                                  </Button>
                                )}

                                {orderLists.isEcomList && orderLists.orderType?.toLowerCase() === "delivery" && !orderLists.isDelivered && !orderLists.isCanceled && orderLists.orderStatus?.toLowerCase() !== "confirmed" && orderLists.orderStatus?.toLowerCase().replace(/\s+/g, '') !== "intransit" && (
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    onClick={() => handleOrderStatus("confirm", orderLists.id || orderLists._id, orderLists.isPaid, orderLists)}
                                    style={{
                                      fontWeight: '500',
                                      minWidth: '100px',
                                      fontSize: '0.7rem',
                                      height: '32px',
                                      padding: '4px 8px',
                                      marginRight: '8px'
                                    }}
                                  >
                                    Confirm
                                  </Button>
                                )}

                                {orderLists.orderType?.toLowerCase() === "delivery" && !orderLists.isDelivered && !orderLists.isCanceled && orderLists.orderStatus?.toLowerCase().replace(/\s+/g, '') !== "intransit" && (!orderLists.isEcomList || orderLists.orderStatus?.toLowerCase() === "confirmed") && (
                                  <Button
                                    variant="contained"
                                    color="info"
                                    size="small"
                                    onClick={() => openDeliveryDialog(orderLists)}
                                    startIcon={<LocalShippingIcon />}
                                    style={{
                                      fontWeight: '500',
                                      minWidth: '100px',
                                      fontSize: '0.7rem',
                                      height: '32px',
                                      padding: '4px 8px',
                                      marginRight: '8px'
                                    }}
                                  >
                                    InTransit
                                  </Button>
                                )}



                                {orderLists.orderType?.toLowerCase() === "delivery" ? (
                                  orderLists.orderStatus?.toLowerCase().replace(/\s+/g, '') === "intransit" && !orderLists.isDelivered && !orderLists.isCanceled && (
                                    <Button
                                      variant="contained"
                                      color="success"
                                      size="small"
                                      onClick={() => handleOrderStatus("deliver", orderLists.id || orderLists._id, orderLists.isPaid, orderLists)}
                                      startIcon={<DeliveryDiningIcon />}
                                      style={{
                                        fontWeight: '500',
                                        minWidth: '120px',
                                        fontSize: '0.7rem',
                                        height: '32px',
                                        padding: '4px 8px'
                                      }}
                                    >
                                      Mark delivered
                                    </Button>
                                  )
                                ) : (
                                  !orderLists.isEcomList && merchantData?.bizVertical === 'restaurant' && !allServed && !orderLists.isCanceled && (
                                    <Button
                                      variant="contained"
                                      color="success"
                                      size="small"
                                      onClick={() => HandleServed([orderLists])}
                                      startIcon={<DinnerDining />}
                                      style={{
                                        fontWeight: '500',
                                        minWidth: '100px',
                                        fontSize: '0.7rem',
                                        height: '32px',
                                        padding: '4px 8px'
                                      }}
                                    >
                                      All Served
                                    </Button>
                                  )
                                )}
                              </div>
                            </div>

                            {/* Second Row  */}
                            <div style={{
                              display: 'flex',
                              gap: '10px',
                              alignItems: 'center',
                              flexWrap: 'wrap',
                              justifyContent: 'space-between'
                            }}>
                              <div style={{
                                display: 'flex',
                                gap: '10px',
                                alignItems: 'center',
                                flexWrap: 'wrap'
                              }}>
                              </div>

                              <div style={{
                                display: 'flex',
                                gap: '10px',
                                alignItems: 'center',
                                flexWrap: 'wrap'
                              }}>




                                {/* Cancelled Status */}
                                {orderLists.isCanceled && (
                                  <Chip
                                    label="CANCELLED"
                                    color="error"
                                    style={{
                                      fontSize: "x-small",
                                      fontWeight: "bold",
                                      minWidth: '85px',
                                      height: '32px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                    }}
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                ) : (
                  <div style={{
                    textAlign: 'center',
                    padding: '40px',
                    gridColumn: '1 / -1',
                    background: '#f8f9fa',
                    borderRadius: '12px',
                    border: '1px dashed #dee2e6'
                  }}>
                    <h5 style={{ color: '#6c757d', margin: 0 }}>No data available for this date</h5>
                  </div>
                )}
              </div>
            ) : (
              // Table View for Main Orders 
              <Table breakPoint={700} style={{ width: "100%" }}>
                <Thead>
                  <Tr>
                    <Th>#Token</Th>
                    <Th>Source</Th>
                    <Th>Amount (Inc Tax)</Th>
                    <Th>Order Items</Th>
                    <Th></Th>
                    <Th></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {filteredOrders.length ? (
                    (isReversed ? filteredOrders.slice().reverse() : filteredOrders).map((orderLists, index) => {
                      let paidStaus = notifiData.filter((nof) => orderLists.number === nof.token);
                      let payStatus = paidStaus.length ? true : false;
                      let tableCall = false;

                      if (orderLists.orderSource === "Table Order") {
                        const table = tableData && tableData.filter((tab) => tab.number == orderLists.number);
                        tableCall = table ? table[0] ? table[0].isServiceCall : "" : "";
                      }

                      return (
                        <Tr
                          style={
                            orderLists.isCanceled === true
                              ? {
                                backgroundColor: "#fbe3e3cc",
                                borderBottom: "1px solid #f0eeee",
                                margin: "5px",
                              }
                              : {
                                borderBottom: "1px solid #f0eeee",
                                margin: "5px",
                                backgroundColor: "#fff",
                                borderRadius: "8px"
                              }
                          }
                        >
                          <Td
                            style={{
                              fontSize: "20px",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              color: "#4d4a4a",
                            }}
                          >
                            {orderLists.number}
                            <br />
                            {tableCall && (
                              <span
                                className={orderLists.isDelivered ? "" : "shaking-icon"}
                                style={{
                                  display: "inline-block",
                                  fontSize: "9px",
                                  fontWeight: "bold",
                                  left: "35px",
                                }}
                              >
                                <NotificationsActiveIcon sx={{ color: "red" }} fontSize="small" />
                              </span>
                            )}

                            {orderLists.orderType.toLowerCase() === "eat in" && (
                              <img height="40px" alt="" width="40px" src="/images/eat_in.png" />
                            )}
                            {(orderLists.orderType.toLowerCase() === "take away" ||
                              orderLists.orderType.toLowerCase() === "pick up") && (
                                <img height="40px" width="40px" alt="" src="/images/take-out-2.png" />
                              )}
                            {orderLists.orderType === "Table Order" && (
                              <img height="40px" width="40px" alt="" src="/images/tableOrder.png" />
                            )}
                            {orderLists.orderType.toLowerCase() === "delivery" && (
                              <DeliveryDiningIcon style={{ height: "30px", width: "30px" }} />
                            )}
                          </Td>
                          <Td>
                            <Chip
                              label={orderLists.orderSource || "Self Order"}
                              color={
                                (orderLists.orderSource || "Self Order") === "EPOS"
                                  ? "info"
                                  : (orderLists.orderSource || "Self Order") === "Self Order"
                                    ? "warning"
                                    : (orderLists.orderSource || "Self Order") === "Table Order"
                                      ? "secondary"
                                      : (orderLists.orderSource || "Self Order") === "Online Order"
                                        ? "error"
                                        : "default"
                              }
                              style={{
                                marginLeft: "10px",
                                fontSize: "x-small",
                                fontWeight: "bold",
                              }}
                            />
                            <div style={{ fontSize: "12px" }}>
                              {moment(orderLists.scheduleDate || orderLists.createdAt).format("DD-MMM h:mm a")}
                            </div>
                          </Td>

                          <Td>
                            {selectedCurrency}
                            {(orderLists.totalPrice).toFixed(2)}

                            {!orderLists.isPaid ? (
                              <Chip
                                label="PENDING"
                                style={{
                                  fontSize: "x-small",
                                  fontWeight: "bold",
                                  background: "#fdd564",
                                  color: "#6f650e",
                                }}
                              />
                            ) : (
                              <Chip
                                label="✔ PAID"
                                color="success"
                                style={{
                                  fontSize: "x-small",
                                  fontWeight: "bold",
                                }}
                              />
                            )}
                          </Td>

                          <Td style={{ fontSize: "12px" }}>
                            <button
                              className="btn-icon"
                              onClick={() =>
                                orderListHandler(
                                  orderLists.id,
                                  orderLists.customerId,
                                  orderLists
                                )
                              }
                            >
                              <ReceiptLongOutlinedIcon />
                            </button>
                            {members.length && orderLists.servedByMemeberId ? (
                              <div>{'Serve by: ' + members.filter(mb => mb.id == orderLists.servedByMemeberId)[0].firstName}</div>
                            ) : ""}
                          </Td>
                          <Td>
                            <div style={{ display: "flex" }}>
                              {orderLists.orderItems?.every((item) => item.status === "delivered") ? (
                                <Chip
                                  label="✔ DELIVERED"
                                  color="success"
                                  style={{
                                    marginLeft: "5px",
                                    fontSize: "x-small",
                                    fontWeight: "bold",
                                    cursor: "pointer",
                                  }}
                                />
                              ) : (
                                merchantData?.bizVertical === 'restaurant' ? (
                                  <img style={{ width: "50px" }} src="./chef.gif" alt="Preparing" />
                                ) : null
                              )}
                              {!orderLists.isPaid && !orderLists.isCanceled && (
                                <Button
                                  variant="contained"
                                  color="error"
                                  onClick={(e) => {
                                    setPayModeSelectDialog(true);
                                    setSelectedOrder(orderLists);
                                  }}
                                  style={{
                                    display: orderLists.isPaid ? "none" : "inline-block",
                                    cursor: "pointer",
                                    margin: "0px 10px",
                                  }}
                                >
                                  Pay Now
                                </Button>
                              )}
                            </div>
                          </Td>
                          <Td>
                            <div className="actions-container" style={{ position: "relative" }}>
                              {!orderLists.isCanceled && (
                                <Button
                                  style={{ marginRight: "10px" }}
                                  aria-controls={
                                    openActions && selectedOrder?.id === orderLists.id
                                      ? `actions-menu-${orderLists.id}`
                                      : undefined
                                  }
                                  aria-haspopup="true"
                                  aria-expanded={
                                    openActions && selectedOrder?.id === orderLists.id
                                      ? "true"
                                      : "false"
                                  }
                                  variant="outlined"
                                  onClick={(event) => {
                                    if (openActions && selectedOrder?.id === orderLists.id) {
                                      setOpenActions(false);
                                    } else {
                                      setSelectedOrder(orderLists);
                                      const buttonElement = event.currentTarget;
                                      const buttonRect = buttonElement.getBoundingClientRect();
                                      const spaceBelow = window.innerHeight - buttonRect.bottom;
                                      const dropdownHeight = 200;
                                      const spaceAbove = buttonRect.top;

                                      if (spaceBelow < dropdownHeight) {
                                        setDropdownPosition("up");
                                      } else {
                                        setDropdownPosition("down");
                                      }
                                      setOpenActions(true);
                                    }
                                  }}
                                  endIcon={<KeyboardArrowDownIcon />}
                                >
                                  Actions
                                </Button>
                              )}

                              {openActions && orderLists.id === selectedOrder.id && (
                                <ClickAwayListener
                                  onClickAway={() => setOpenActions(false)}
                                  touchEvent="touchstart"
                                >
                                  <Paper
                                    id={`actions-menu-${orderLists.id}`}
                                    style={{
                                      position: "absolute",
                                      left: 0,
                                      zIndex: "99",
                                      maxHeight: "200px",
                                      overflowY: "auto",
                                      minWidth: "150px",
                                      backgroundColor: "white",
                                      border: "1px solid #ddd",
                                      boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                                      ...(dropdownPosition === "down"
                                        ? { top: "100%" }
                                        : { bottom: "100%" }),
                                    }}
                                  >
                                    <MenuList>
                                      {!orderLists.isPaid && !orderLists.isCanceled && (
                                        <MenuItem
                                          onClick={() => (setOpenActions(false), handleOpenPopup(orderLists))}
                                        >
                                          <DiscountIcon />
                                          Add Discount
                                        </MenuItem>
                                      )}
                                      {!orderLists.isPaid && (
                                        <MenuItem
                                          onClick={() => (setOpenActions(false), handleUpdateOrder(orderLists))}
                                        >
                                          <EditIcon />
                                          Update Order
                                        </MenuItem>
                                      )}
                                      <MenuItem
                                        onClick={() => (handlecheckprint(orderLists), setOpenActions(false))}
                                      >
                                        <PrintIcon color="success" />
                                        Print Order
                                      </MenuItem>
                                      {!orderLists.isEcomList && merchantData?.bizVertical === "restaurant" && <MenuItem
                                        onClick={() => (handlecheckprintKOT(orderLists), setOpenActions(false))}
                                      >
                                        <PrintIcon color="success" />
                                        KOT
                                      </MenuItem>}

                                      {!userData?.isIAM && !orderLists.isDelivered && !orderLists.isCanceled && (
                                        <MenuItem
                                          onClick={() => (
                                            setOpenActions(false),
                                            handleCancel(
                                              orderLists.id || orderLists._id,
                                              orderLists.isCanceled,
                                              orderLists.tableId,
                                              orderLists.number
                                            )
                                          )}
                                        >
                                          <CancelIcon color="error" />
                                          {orderLists.isPaid ? "Refund" : "Cancel"}
                                        </MenuItem>
                                      )}
                                      {orderLists.orderType === "Delivery" &&
                                        orderLists.isPaid &&
                                        orderLists.orderItems.every((item) => item.status === "ready") && (
                                          <MenuItem
                                            onClick={() => handleAssignDriverClick(orderLists)}
                                          >
                                            <DeliveryDiningIcon color="success" />
                                            Assign Driver
                                          </MenuItem>
                                        )}
                                      {orderLists.orderType?.toLowerCase() === "delivery" && !orderLists.isDelivered && !orderLists.isCanceled && orderLists.orderStatus?.toLowerCase().replace(/\s+/g, '') === "intransit" && (
                                        <MenuItem
                                          onClick={() => (setOpenActions(false), openDeliveryDialog(orderLists))}
                                        >
                                          <EditIcon color="primary" />
                                          Edit Delivery
                                        </MenuItem>
                                      )}

                                      {orderLists.orderType === "Table Order" && (
                                        <MenuItem
                                          onClick={() => handleAssignServerClick(orderLists)}
                                        >
                                          <DinnerDining color="success" />
                                          Server
                                        </MenuItem>
                                      )}
                                    </MenuList>
                                  </Paper>
                                </ClickAwayListener>
                              )}

                              {orderLists.isCanceled && (
                                <Chip
                                  label="CANCELLED"
                                  color="error"
                                  style={{
                                    marginLeft: "10px",
                                    fontSize: "x-small",
                                    fontWeight: "bold",
                                    cursor: "pointer",
                                  }}
                                />
                              )}
                            </div>
                          </Td>
                        </Tr>
                      );
                    })
                  ) : (
                    <div className="">
                      <h5 className="">No data available for this date</h5>
                    </div>
                  )}
                </Tbody>
              </Table>
            )}
          </div>

          {confirmRejectTempOrder && (
            <DeleteDiaologue
              msg="reject"
              open={confirmRejectTempOrder}
              onClose={() => {
                setConfirmRejectTempOrder(false);
                setTempOrderToRejectId(null);
              }}
              onConfirm={async () => {
                await rejectOrder(tempOrderToRejectId);
                setConfirmRejectTempOrder(false);
                setTempOrderToRejectId(null);
              }}
            />
          )}

          <style jsx>{`
    @keyframes shake {
      0%, 100% { transform: translateX(0); }
      25% { transform: translateX(-2px); }
      75% { transform: translateX(2px); }
    }
    
    .shaking-icon {
      animation: shake 0.5s ease-in-out infinite;
    }
    
    .custom-scrollbar::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    
    .custom-scrollbar::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 3px;
    }
    
    .custom-scrollbar::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 3px;
    }
    
    .custom-scrollbar::-webkit-scrollbar-thumb:hover {
      background: #a8a8a8;
    }
    
    .custom-scrollbar {
      scrollbar-width: thin;
      scrollbar-color: #c1c1c1 #f1f1f1;
    }
  `}</style>
        </div>

      </div>

      {/* Bill Popup */}
      <BillPopup
        open={billPopupOpen}
        onClose={handleClosePopup}
        billDetails={billDetails}
      />

      <AssignDriverPopup
        open={selectedOrderForDriver && assignPopupOpen}
        onClose={() => (setAssignPopupOpen(false), fetchOrdersAndNoti())}
        onAssign={handleDriverAssign}
        authApi={authApi}
        userToken={userToken}
        userid={userData?.sub}
      />

      <AssignWaiterPopup
        open={selectedOrderForServer && assignPopupOpen}
        onClose={() => (setAssignPopupOpen(false), fetchOrdersAndNoti())}
        onAssign={handleWaiterAssign}
        authApi={authApi}
        userToken={userToken}
        userid={userData?.sub}
      />

      <Dialog
        className="dialog-box"
        maxWidth="md"
        fullWidth={true}
        open={isOpen}
      >
        <DialogTitle style={{ fontWeight: "bold" }}>
          {t({ id: "order_summary_token" })}: #
          <span style={{ fontSize: "35px" }}>{token}</span>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => handleClose()}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers>
          <div
            style={
              customerorderpop
                ? {
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  gap: "10px",
                }
                : { display: "none" }
            }
          >
            <h5>
              {t({ id: "name" })}: <span>{customerData.firstName}</span>
            </h5>
            <h5>
              {t({ id: "mobile_no" })}: <span>{customerData.phone}</span>
            </h5>
            <h5>
              {t({ id: "address" })}: <span>{customerData.address}</span>
            </h5>
          </div>
          <Table breakPoint={700} style={{ width: "100%", textAlign: "left" }}>
            <Thead>
              <Tr>
                <Th>{t({ id: "name" })}</Th>
                <Th>{t({ id: "quantity" })}</Th>
                {/* <th>Action</th> */}
              </Tr>
            </Thead>
            <tbody style={{ textAlign: "left !important" }}>
              {orderItemsList.length
                ? orderItemsList.map((orderItem) => {
                  console.log(orderItem);
                  const subProArray =
                    typeof orderItem.sub_pro === "string"
                      ? JSON.parse(orderItem.sub_pro)
                      : orderItem.sub_pro;
                  console.log(subProArray);
                  const subProNames = Array.isArray(subProArray?.addons)
                    ? subProArray.addons.map((subPro) => subPro.name)
                    : [];

                  const subProInstruction = Array.isArray(
                    subProArray?.cookInstructions
                  )
                    ? subProArray.cookInstructions
                    : [];

                  const subProVariety =
                    subProArray?.variety &&
                      typeof subProArray.variety === "object"
                      ? Object.keys(subProArray.variety)[0] || ""
                      : "";


                  return (
                    <Tr id="trow">
                      <Td>
                        <b>{orderItem.name}</b> <br />{" "}
                        {subProNames.length > 0 ? (
                          <Chip
                            label={subProNames.join(", ").toUpperCase()}
                            color="primary"
                            style={{
                              marginLeft: "10px",
                              fontSize: "10px",
                              fontWeight: "bold",
                            }}
                          />
                        ) : (
                          subProNames
                        )}
                        <Chip
                          label={subProInstruction.join(", ").toUpperCase()}
                          color="primary"
                          style={{
                            marginLeft: "10px",
                            fontSize: "8px",
                            fontWeight: "bold",
                          }}
                        />
                        <Chip
                          label={subProVariety.toUpperCase()}
                          color="primary"
                          style={{
                            marginLeft: "10px",
                            fontSize: "10px",
                            fontWeight: "bold",
                          }}
                        />
                        {orderItem.appliedOfferDescription && (
                          <Chip
                            label={orderItem.appliedOfferDescription.toUpperCase()}
                            color="info"
                            style={{
                              marginLeft: "10px",
                              fontSize: "10px",
                              fontWeight: "bold",
                            }}
                          />
                        )}
                      </Td>
                      <Td>
                        {orderItem.select_type === "weight"
                          ? orderItem.quantity >= 1000
                            ? `${(orderItem.quantity / 1000).toFixed(
                              orderItem.quantity % 1000 === 0 ? 0 : 1
                            )} kg`
                            : `${orderItem.quantity} g`
                          : orderItem.quantity}
                      </Td>
                      <Td>
                        {selectedOrd?.[0]?.orderType === "Table Order" ||
                          selectedOrd?.[0]?.isPaid ? (
                          orderItem.status === "delivered" ? (
                            <span
                              style={{
                                color: "green",
                                fontSize: "small",
                                fontWeight: "bold",
                              }}
                            >
                              {t({ id: "completed" })}
                            </span>
                          ) : orderItem.status === "ready" ? (
                            <Button
                              id="btnserved"
                              variant="contained"
                              color="success"
                              onClick={() =>
                                HandleServed(selectedOrd, orderItem._id)
                              }
                            >
                              {t({ id: "serve" })}
                            </Button>
                          ) : (
                            <Button
                              id="btnready"
                              variant="contained"
                              color="primary"
                              onClick={() =>
                                HandleReady(selectedOrd, orderItem._id)
                              }
                            >
                              {t({ id: "ready" })}
                            </Button>
                          )
                        ) : null}
                      </Td>
                    </Tr>
                  );
                })
                : ""}
            </tbody>
          </Table>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            color="error"
            style={{ float: "right", marginTop: "8px" }}
            className="btn btn-danger m-2 btn-small"
            onClick={handleClose}
          >
            {t({ id: "close" })}
          </Button>
        </DialogActions>

      </Dialog>

      <Dialog open={edit} maxWidth="xs" className="pd-2" fullWidth={true}>
        <DialogTitle className="text-center  fw-bold">{itemName}</DialogTitle>
        <form onSubmit={(e) => habdleSubmit(e)} className="p-2">
          <label className="fw-bold mx-2">{t({ id: "item_quantity" })}</label>
          <input
            type="number"
            onChange={handleInput}
            value={editQuantity}
            height="20px"
            width="20px"
            className="form-control w-50 mx-2 "
          />

          <button type="submit" className="btn btn-success m-2 save-btn">
            {t({ id: "save" })}
          </button>

          <button
            onClick={() => setEdit(false)}
            className="btn btn-danger btn-xs m-2 "
            variant="outlined"
          >
            {t({ id: "close" })}
          </button>
        </form>
      </Dialog>

      <Dialog
        open={payModeSelectDialog}
        maxWidth="md"
        className="pd-2"
        onClose={() => setPayModeSelectDialog(false)}
      >
        <DialogTitle className="text-center  fw-bold">
          {" "}
          {t({ id: "pay_mode" })}
        </DialogTitle>
        <div style={{ padding: "10px", minWidth: "450px" }}>
          <PaymentOptions
            handlePaymentClick={setPayModeSelectDialog}
            handlePayMode={handlePayment}
            payModeIndx={payModeIndx}
            setPayModeIndx={setPayModeIndx}
            order={selectedOrder}
            userData={merchantData}
            closeParentDialog={() => setPayModeSelectDialog(false)}
          />
          <Button
            variant="outlined"
            color="error"
            style={{ float: "right", marginTop: "8px" }}
            className="btn btn-danger m-2 btn-small"
            onClick={() => setPayModeSelectDialog(false)}
          >
            {t({ id: "close" })}
          </Button>
        </div>
      </Dialog>
      <Dialog
        open={payConfirmDialog}
        style={{ zIndex: 9999999 }}
      >
        <div class="modal-body" style={{ height: "600px" }}>
          <iframe id="txFrame" src={payConfirmDialog} frameborder="0" allowtransparency="true" style={{ width: "100%", height: "100%" }}></iframe>
        </div>
      </Dialog>
      <Dialog open={isDeliveryDialogOpen} onClose={() => setIsDeliveryDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Delivery Details</DialogTitle>
        <DialogContent>
          <TextField
            select
            label="Delivery Partner"
            value={deliveryFormData.deliveryPartnerCode}
            onChange={e => setDeliveryFormData({ ...deliveryFormData, deliveryPartnerCode: e.target.value })}
            fullWidth
            margin="dense"
          >
            {deliveryPartners.map(dp => (
              <MenuItem key={dp.code} value={dp.code}>
                {dp.name}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            label="Tracking ID"
            value={deliveryFormData.trackingId}
            onChange={e => setDeliveryFormData({ ...deliveryFormData, trackingId: e.target.value })}
            fullWidth
            margin="dense"
          />
          <TextField
            label="Tracking URL"
            value={deliveryFormData.trackingUrl}
            onChange={e => setDeliveryFormData({ ...deliveryFormData, trackingUrl: e.target.value })}
            fullWidth
            margin="dense"
          />
          <TextField
            label="Third Party Order ID"
            value={deliveryFormData.thirdPartyOrderId}
            onChange={e => setDeliveryFormData({ ...deliveryFormData, thirdPartyOrderId: e.target.value })}
            fullWidth
            margin="dense"
          />
          <TextField
            label="Delivery Fee"
            type="number"
            value={deliveryFormData.deliveryFee}
            onChange={e => setDeliveryFormData({ ...deliveryFormData, deliveryFee: e.target.value })}
            fullWidth
            margin="dense"
          />
          <TextField
            label="Delivery Notes"
            multiline
            rows={3}
            value={deliveryFormData.deliveryNotes}
            onChange={e => setDeliveryFormData({ ...deliveryFormData, deliveryNotes: e.target.value })}
            fullWidth
            margin="dense"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsDeliveryDialogOpen(false)} color="secondary">
            Cancel
          </Button>
          <Button variant="contained" color="primary" onClick={handleSaveDeliveryDetails}>
            Save & In Transit
          </Button>
        </DialogActions>
      </Dialog>
      <ToastContainer />
    </div>
  );
};

export default OrderList;